import React, {
  Dispatch,
  FC,
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  CloseOutlined,
  DeleteTwoTone,
  LoadingOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  DrawerProps,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  TreeSelect,
  Upload,
} from "antd";
import { useClient } from "../../../Context/ClientContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import phoneImg from "../../../../images/phoneIcon.svg";

import emailImg from "../../../../images/emailIcon.svg";
import {
  BusinessNaturesTypeOptions,
  BusinessTypeOptions,
  GSTTypeOptions,
  GSTTypeOptionsIndividual,
} from "../../Clients/Clients";
import "../../../Common/AddPageCommon.css";
import LedgerService, {
  Duties_Calc_Methods,
  Duty_Type,
  GSTTax_Type,
  MasterName,
  PartyType,
  SearchLedgerByGroupsTypes,
  TypeOfAddress,
} from "../../../Services/LedgerService";
import AddGroup from "../Group/AddGroup";
import { CompanyGSTTypes } from "../../../../Types/CommonConstants";
import {
  BankAccountTypes,
  DeducteeTypes,
  getTDSDeducteeTypeName,
} from "../../../Services/ClientService";
import { useHotkeys } from "react-hotkeys-hook";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";
import DocumentPreview from "../../../Common/DocumentPreview";
import { useUser } from "../../../../Context/UserContext";
import ReportsServiceNew, {
  GroupList_Type,
} from "../../../Services/ReportsServiceNew";
import {
  allCountriesStates,
  countryOptionsOnlyIndia,
  countryOptionsWithOutIndia,
} from "../../../../Types/CommonAllCountriesStates";
import { premissionLedgerAndGroup } from "../../Users/Roles/UserSecurityFind";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { addressObject } from "../../../Services/SettingService";
import { useHotkey } from "../../../Context/HotKeyContext";
import Party from "../../Parties/Party";

export interface IDefaultGroup {
  id: string;
  ledgerName: string;
  parent: string;
}

export const AddLedger: FC<{
  openDrawer: boolean;
  id: any;
  setOpenDrawer: Dispatch<{}>;
  setTrigger?: any;
  name?: string;
  type?: SearchLedgerByGroupsTypes;
  setAddLedgerResponse?: any;
  defaultGroup?: IDefaultGroup;
  showName?: string;
  placement?:DrawerProps["placement"]
}> = (props) => {
  // console.log("props............", props);
  const { showKeys } = useHotkey();
  const { currentClient, companySettings } = useClient();
  const [form] = Form.useForm();
  const { getAllIndStates } = useUser();
  const stateOptions: any = getAllIndStates();
  const autoCompleteRef = useRef<any>(null);
  const [width, SetWidth] = useState<any>(window.innerWidth);
  const [groupListTrigger, setGroupListTrigger] = useState<boolean>(false);
  const [bankTypeValue, setBankTypeValue] = useState<BankAccountTypes>(
    BankAccountTypes.CurrentAccount
  );
  const [bankDefaultChecked, setBankDefaultChecked] = useState<boolean[]>([
    false,
  ]);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [checkbox, setCheckbox] = useState<number>(0);
  const [gSTTypeValue, setGSTTypeValue] = useState<CompanyGSTTypes>(
    CompanyGSTTypes.Unregistered
  );
  const { openNotification } = useContext(notificationContext);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [loading, setLoading] = useState<boolean>(false);
  const [isPartyCompany, setIsPartyCompany] = useState<PartyType>(
    (props.type === SearchLedgerByGroupsTypes.PartiesOnly ||
      props.type === SearchLedgerByGroupsTypes.DebtorsOnly ||
      props.type === SearchLedgerByGroupsTypes.CreditorsOnly) &&
      props?.showName !== "Transporter"
      ? PartyType.IndividualPerson
      : PartyType.CompanyFirm
  );
  const [editTimeIsCompany, setEditTimeIsCompany] = useState<PartyType>(
    PartyType.IndividualPerson
  );
  const [groupData, setGroupData] = useState<any[]>([]);
  const [findGroupData, setFindGroupData] = useState<any[]>([]);
  const [ledgerList, setLedgerList] = useState<any[]>();
  const [country, setCountry] = React.useState<any>(
    countryOptionsOnlyIndia?.[0]?.value
  );
  const [partyViewDetails, setPartyViewDetails] = useState<{
    sundryCreditor: boolean;
    sundryDebtors: boolean;
  }>({
    sundryCreditor: false,
    sundryDebtors: false,
  });
  const [isPartTDSOrTDS, setIsPartTDSOrTDS] = React.useState<{
    tds: Boolean;
    tcs: Boolean;
  }>({ tds: false, tcs: false });

  const [openModel, setOpenModel] = useState<{
    open: boolean;
    param: any;
  }>({
    open: false,
    param: "",
  });
  const [bankViewDetails, setBankViewDetails] = useState<boolean>(false);
  const [ccViewDetails, setCCViewDetails] = useState<boolean>(false);
  const [dutiesAndTaxesDetails, setDutiesAndTaxesDetails] =
    useState<boolean>(false);
  const [expensesAndIncomesDetails, setExpensesAndIncomesDetails] =
    useState<boolean>(false);
  const [showFiledDutiedandTaxes, setShowFiledDutiedandTaxes] = useState<{
    taxInDigit: boolean;
    taxInSelect: boolean;
    gstType: boolean;
    calcMethod: boolean;
  }>({
    taxInDigit: false,
    taxInSelect: false,
    gstType: false,
    calcMethod: false,
  });
  const [showDetailsTSC, setShowDetailsTSC] = useState<boolean>(false);
  const [showDetailsTDS, setShowDetailsTDS] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);
  const [deleteUploadId, setDeleteUploadId] = useState<string[]>([]);
  const [previewImage, setPreviewImage] = useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });
  const [groupDropdownloading, setGroupDropdownLoading] = React.useState(true);
  const [addGroupVal, setAddGropVal] = React.useState<any>();
  const [showPersonCompany, setShowPersonCompany] =
    React.useState<boolean>(false);
  const [billingAddCountry, setBillingAddCountry] = useState<string>("IN");
  const [billingAddCountryData, setBillingAddCountryData] = useState<any>({});
  const [ledgerAvailable, setLedgerAvailable] = useState<boolean>(false);
  const [shippingAddCountry, setShippingAddCountry] = useState<string>("IN");
  const [shippingAddCountryData, setShippingAddCountryData] = useState<any>({});
  const [selectCountry, setSelectCountry] = useState<string[]>([]);
  const isVendorChecked = Form.useWatch("isVendor", form);
  const handlePartyTypeChange = (value: PartyType) => {
    if (value === PartyType.CompanyFirm) {
      if (gSTTypeValue === CompanyGSTTypes.Overseas) {
        setGSTTypeValue(CompanyGSTTypes.Overseas);
        form.setFieldValue("gstType", CompanyGSTTypes.Overseas);
      } else {
        setGSTTypeValue(CompanyGSTTypes.Unregistered);
        form.setFieldValue("gstType", CompanyGSTTypes.Unregistered);
      }
    } else {
      if (gSTTypeValue === CompanyGSTTypes.Overseas) {
        setGSTTypeValue(CompanyGSTTypes.Overseas);
        form.setFieldValue("gstType", CompanyGSTTypes.Overseas);
      } else {
        setGSTTypeValue(CompanyGSTTypes.Consumer);
        form.setFieldValue("gstType", CompanyGSTTypes.Consumer);
      }
    }
  };

  const handleIsDefaultChange = (index: number) => {
    const currentValues = form.getFieldValue("contactInformation") || [];
    const updatedValues = currentValues.map((item: any, idx: number) => ({
      ...item,
      isDefault: idx === index, // Ensure only the current index is set to true
    }));
    form.setFieldsValue({ contactInformation: updatedValues });
  };
  // const handleInputChange = (value: any) => {
  //   setInputValue(value);
  //   // setOpen(value.length > 0);
  // };
  const handleInputChange = (value: any) => {
    let ledDetail = ledgerList?.filter(
      (led: any) => led.ledgerName.toLowerCase() === value.toLowerCase()
    );
    setLedgerAvailable(ledDetail?.length! > 0 ? true : false);
  };

  // const countryOptions = Countries.map((country) => ({
  //   label: country.name,
  //   value: country.code,
  // }));
  useEffect(() => {
    if (props?.showName === "Transporter") {
      setEditTimeIsCompany(PartyType.CompanyFirm);
      form.setFieldValue("isTransporter", true);
    }
  }, []);
  const DeducteeTypesOptions = Object.keys(DeducteeTypes)
    .filter((type) => !isNaN(Number(type)))
    .map((type: any) => {
      return {
        key: Number(type),
        label: getTDSDeducteeTypeName(type),
        value: Number(type),
      };
    });

  const handleDelBankDetail = (nameIndex: number) => {
    setBankDefaultChecked((prevDetail: any) => {
      let newDetail;
      let selIndex = prevDetail.indexOf(true);
      if (selIndex === -1) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        newDetail = newDetail.map((d: any) => (d = false));
        newDetail[0] = true;
      } else if (selIndex === nameIndex) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        if (newDetail !== 0) {
          newDetail[0] = true;
        }
      } else if (selIndex < nameIndex) {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
      } else {
        newDetail = prevDetail.filter(
          (_: any, index: number) => index !== nameIndex
        );
        newDetail = newDetail.map((d: any) => (d = false));
        newDetail[selIndex - 1] = true;
      }
      console.log("Udated BankDetail", newDetail);

      return newDetail;
    });
  };

  const setBankDefaultValueHandler = (val: any, nameIndex: number) => {
    setBankDefaultChecked(() => {
      let bankVal = form.getFieldValue("bankDetail");
      if (bankVal === null) {
        return [false];
      } else {
        return bankVal?.map((bankVal: any, index: number) =>
          index === nameIndex && val === true ? true : false
        );
      }
    });
  };

  // const gstOption = companySettings?.setting?.gstDetails?.gst;
  const gstOption = companySettings?.gsts ?? [];

  const handlePANNo = (e: any) => {
    const { value } = e.target;
    form.setFieldValue("pan", value.slice(2, 12));
    form.setFieldValue("state", Number(value.slice(0, 2)));
  };

  const onDismissConfirm = () => {
    setConfirmation(false);
    props.setOpenDrawer({ open: false, param: "" });
  };

  const onDismissBothModels = () => {
    // setTouched(false);
    setConfirmation(false);
    props.setOpenDrawer({ open: false, param: "" });
    // setErrorForBName(false);
    form.resetFields();
  };

  console.log("selectCountry", selectCountry);

  // ----- get group list api -----
  useEffect(() => {
    // inputRef.current?.focus();
    // const getListData = async () => {
    //   setGroupDropdownLoading(true);
    //   let temp = await ChartofAccountServicesNew.getGroupList(
    //     currentClient?.id!,
    //     currentClient?.productModule,
    //     "",
    //     "",
    //     "",
    //     "",
    //     props?.type
    //   );
    //   if (temp) {
    //     setGroupData(temp.items);
    //     setGroupDropdownLoading(false);
    //     if (props.defaultGroup?.id && !props.id) {
    //       findParentGroup(
    //         props.defaultGroup?.parent,
    //         props.defaultGroup?.ledgerName,
    //         props.defaultGroup?.id
    //       );
    //       form.setFieldValue("parent", {
    //         value: props.defaultGroup?.id,
    //         label: props.defaultGroup?.ledgerName,
    //         title: props.defaultGroup?.parent,
    //       });
    //     }
    //     // if (props.editData.id) {
    //     //   setGroupType(props.editData?.group_Type);
    //     //   form.setFieldsValue(props.editData);
    //     // }

    //     setLoading(false);
    //     setGroupDropdownLoading(false);
    //   } else {
    //     setGroupData([]);
    //     console.log("Error", temp);
    //     setLoading(false);
    //     setGroupDropdownLoading(false);
    //   }
    // };

    const getListData = async () => {
      setLoading(true);
      await ReportsServiceNew.getGroupHierarchy(
        currentClient?.id!,
        undefined,
        undefined,
        "",
        GroupList_Type.All,
        props?.type
      )
        .then((res: any) => {
          let index = 0;
          const dataSetInApi = (allgroupList: any[]) => {
            // console.log("allgroupList", allgroupList);
            return allgroupList.map((x: any) => {
              const node: any = {
                // key: (index += 1),
                id: x?.id,
                parent: x?.parent,
                value: x?.id,
                title: x?.name,
                nature: x?.nature,
                statement: x?.statement,
              };
              if (x?.children?.length > 0) {
                node.children = dataSetInApi(x?.children);
              }
              return node;
            });
          };

          const flattenedData = dataSetInApi(res?.groupList);
          setGroupData(flattenedData);

          console.log("treeData...............", flattenedData);
          setGroupDropdownLoading(false);

          // console.log("result", res);
        })
        .catch((err: any) => {
          // console.log("error", err);
          setGroupData([]);
        });
    };
    getListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupListTrigger]);

  useEffect(() => {
    const allParentGroup = async () => {
      try {
        const res = await ReportsServiceNew.getGroupHierarchy(
          currentClient?.id!,
          undefined,
          undefined,
          "",
          GroupList_Type.All,
          SearchLedgerByGroupsTypes.All
        );
        if (res) {
          const findParentGroupDataApi = (allgroupList: any[]) => {
            let result: any[] = [];
            allgroupList.forEach((x: any) => {
              const node: any = {
                ...x,
              };
              // console.log("index........................", node);
              result.push(node);
              if (x?.children?.length > 0) {
                result = result.concat(findParentGroupDataApi(x?.children));
              }
            });
            return result;
          };

          const findParentGroupData = findParentGroupDataApi(res?.groupList);
          console.log("findParentGroupData", findParentGroupData);

          setFindGroupData(findParentGroupData);

          if (props.defaultGroup?.id && !props.id) {
            findParentGroup(
              props.defaultGroup?.id,
              props.defaultGroup?.ledgerName,
              props.defaultGroup?.id
            );
            !addGroupVal &&
              form.setFieldValue("parent", {
                value: props.defaultGroup?.id,
                label: props.defaultGroup?.ledgerName,
                title: props.defaultGroup?.parent,
              });
          }
          setLoading(false);
        } else {
          setFindGroupData([]);
          setLoading(false);
        }
      } catch (err: any) {
        console.log("error", err);
        setLoading(false);
      }
    };
    allParentGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupListTrigger]);
  //Edit get group data list api (update api)
  useEffect(() => {
    // inputRef.current?.focus();
    if (
      props?.id &&
      groupData.length > 0 &&
      findGroupData.length > 0 &&
      !addGroupVal
    ) {
      setLoading(true);
      const getGroupDeatils = async (id: string) => {
        await LedgerService.getLedgerDetails(currentClient?.id!, id)
          .then((res: any) => {
            console.log("result...........", res);
            if (res?.result) {
              // console.log("getdata---------", res.result, res.result.parent);
              findParentGroup(res.result?.parent);
              // const contactInfo = res.result?.contactInformation?.map(
              //   (itm: any) => {
              //     return {
              //       ...itm,
              //       name: {
              //         ...itm?.name,
              //         title:
              //           itm?.name?.title !== 0 ? itm?.name?.title : undefined,
              //       },
              //     };
              //   }
              // );
              dutiesAndTaxesOnChange(res.result?.typeOfDuty);
              setIsPartyCompany(res?.result?.partyType);
              setEditTimeIsCompany(res?.result?.partyType);
              setIsPartTDSOrTDS({
                tds: res.result?.tdsDeductible,
                tcs: res.result?.ledgerTCSApplicability,
              });
              form.setFieldsValue({
                ...res.result,
                isVendor: res.result?.vendorPortalEmail ? true : false,
                vendorPortalEmail: res.result?.vendorPortalEmail,
                parent: res.result?.parent,
                // gstRate: {
                //   rate: value?.gstRate?.title ?? value?.gstRate,
                //   id: value?.gstRate?.value,
                //   name: value?.gstRate?.label,
                // },
                msmeNo: res?.result?.msmeNo?.replace("UDYAM-", ""),
                addresses: res.result?.addresses?.map(
                  (add: any, index: number) => {
                    if (add?.address?.overseasState) {
                      setSelectCountry((select) => [
                        ...select,
                        add?.address?.country,
                      ]);
                      // if (index === 0) {
                      //   setBillingAddCountryData(
                      //     allCountriesStates.find(
                      //       (x) => x.iso2 === add?.address?.country
                      //     )
                      //   );
                      //   setBillingAddCountry(add?.address?.overseasState);
                      // } else {
                      //   setShippingAddCountryData(
                      //     allCountriesStates.find(
                      //       (x) => x.iso2 === add?.address?.country
                      //     )
                      //   );
                      //   setShippingAddCountry(add?.address?.overseasState);
                      // }
                    }
                    return {
                      ...add,
                      address: {
                        ...add?.address,
                        state:
                          res?.result?.gstType === CompanyGSTTypes.Overseas
                            ? add?.address?.overseasState
                            : add?.address?.state === 0
                            ? undefined
                            : add?.address?.state,
                      },
                      type:
                        res?.result?.partyType === PartyType.IndividualPerson
                          ? TypeOfAddress.RegisteredAddress
                          : add?.type,
                      addressName:
                        res?.result?.partyType === PartyType.IndividualPerson
                          ? index === 0
                            ? "Billing Address"
                            : "Shipping Address"
                          : add?.addressName,
                    };
                  }
                ),
                bankDetail: res.result?.bankDetail
                  ? res.result?.bankDetail
                  : [{}],
                businessType: res?.result?.businessType
                  ? res?.result?.businessType
                  : undefined,
                businessNature:
                  res?.result?.businessNature !== null
                    ? res?.result?.businessNature
                    : [],

                gstRate: res?.result?.id
                  ? {
                      title: res?.result?.gstRate?.rate,
                      value: res?.result?.gstRate?.id,
                      label: res?.result?.gstRate?.name,
                    }
                  : res?.result?.gstRate?.rate,
                contactInformation: res.result?.contactInformation
                  ? res.result?.contactInformation
                  : {},
                // openingBalanceDate:
                //   res.result?.openingBalanceDate === ""
                //     ? undefined
                //     : dayjs(res.result?.openingBalanceDate),
                // sameasAddress:
                //   res.result?.billingAddress === res.result?.shippingAddress,
              });
              // setBankDefaultChecked(
              //   res?.result?.bankDetail !== null
              //     ? res?.result?.bankDetail?.map(
              //         (bankVal: any, index: number) =>
              //           bankVal?.isDefault === true ? true : false
              //       )
              //     : [false]
              // );

              setGSTTypeValue(res?.result?.gstType);
              setCheckbox(
                res.result?.contactInformation
                  ?.map((e: any, i: number) => {
                    return e.isDefault;
                  })
                  .indexOf(true)
              );
              setShowDetailsTSC(res.result?.ledgerTCSApplicability);
              setShowDetailsTDS(res.result?.tdsDeductible);
              setLoading(false);
              setLoading(false);
            } else {
              openNotification(res?.message);
              setLoading(false);
            }
          })
          .catch((err: any) => {
            setLoading(false);
            openNotification(err?.message);
            setLoading(false);

            //console.log("error", err);F
          });
      };
      getGroupDeatils(props?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.id, groupData, findGroupData]);

  // Show drawer fileds function
  const findParentGroup = (
    currId: string,
    defaultGroupName?: string,
    id?: string
  ) => {
    console.log("parent", currId, id, defaultGroupName, "defaultGroupName");
    setPartyViewDetails({ sundryCreditor: false, sundryDebtors: false });
    setBankViewDetails(false);
    setCCViewDetails(false);
    setBankTypeValue(BankAccountTypes.All);
    setDutiesAndTaxesDetails(false);
    setExpensesAndIncomesDetails(false);

    var x = findGroupData.find((x) => x.id === currId);
    console.log("findgroup....", findGroupData, defaultGroupName, x);
    setShowPersonCompany(false);
    if (
      !x?.editable
      // ||      defaultGroupName === "Trade Payables - Sundry Creditors" ||
      // id === "6603afe599242bad67d446d3" ||
      // // defaultGroupName === "Trade Payables - Others" ||
      // defaultGroupName === "Trade Receivables - Sundry Debtors" ||
      // id === "6603afaa99242bad67d446cd" ||
      // // defaultGroupName === "Trade Receivables - Others" ||
      // defaultGroupName === "Bank Account" ||
      // id === "6603af4b99242bad67d446c5" ||
      // defaultGroupName === "Bank OD A/c" ||
      // defaultGroupName === "Duties & Taxes - GST" ||
      // defaultGroupName === "Duties & Taxes - Income Tax" ||
      // defaultGroupName === "Indirect Expenses" ||
      // defaultGroupName === "Indirect Incomes" ||
      // defaultGroupName === "Direct Expenses" ||
      // defaultGroupName === "Direct Incomes"
    ) {
      if (
        x?.name === "Trade Payables - Sundry Creditors" ||
        defaultGroupName === "Trade Payables - Sundry Creditors" ||
        id === "6603afe599242bad67d446d3"
        // x?.name === "Trade Payables - Others" ||
        // defaultGroupName === "Trade Payables - Others"
      ) {
        setPartyViewDetails({ sundryDebtors: true, sundryCreditor: true });
        setShowPersonCompany(true);
      } else if (
        x?.name === "Trade Receivables - Sundry Debtors" ||
        defaultGroupName === "Trade Receivables - Sundry Debtors" ||
        id === "6603afaa99242bad67d446cd"
        // x?.name === "Trade Receivables - Others" ||
        // defaultGroupName === "Trade Receivables - Others"
      ) {
        setPartyViewDetails({ sundryDebtors: true, sundryCreditor: false });
        setShowPersonCompany(true);
      } else if (
        x?.name === "Bank Account" ||
        defaultGroupName === "Bank Account"
      ) {
        if (ccViewDetails) {
          form.setFieldValue(["bankDetail", 0, "accountType"], "");
        }
        setCCViewDetails(false);
        setBankViewDetails(true);
        form.getFieldValue("bankDetail")?.length > 1 &&
          form.setFieldValue("bankDetail", []);
      } else if (
        x?.name === "Bank Account (Short Term Borrowings)" ||
        defaultGroupName === "Bank Account (Short Term Borrowings)"
      ) {
        if (!ccViewDetails) {
          form.setFieldValue(["bankDetail", 0, "accountType"], "");
        }
        setCCViewDetails(true);
        form.getFieldValue("bankDetail")?.length > 1 &&
          form.setFieldValue("bankDetail", []);
      } else if (
        x?.name === "Duties & Taxes - GST" ||
        x?.name === "Duties & Taxes - Income Tax" ||
        defaultGroupName === "Duties & Taxes - GST" ||
        defaultGroupName === "Duties & Taxes - Income Tax"
      ) {
        setDutiesAndTaxesDetails(true);
        setShowFiledDutiedandTaxes({
          taxInDigit: false,
          taxInSelect: true,
          gstType: true,
          calcMethod: false,
        });
      } else if (
        x?.name === "Administrative Expenses" ||
        defaultGroupName === "Administrative Expenses" ||
        x?.name === "Amortisation Expenses" ||
        defaultGroupName === "Amortisation Expenses" ||
        x?.name === "CSR Expenditure" ||
        defaultGroupName === "CSR Expenditure" ||
        x?.name === "Depreciation Expenses" ||
        defaultGroupName === "Depreciation Expenses" ||
        x?.name === "Employee Benefit Expenses" ||
        defaultGroupName === "Employee Benefit Expenses" ||
        x?.name === "Finance Costs" ||
        defaultGroupName === "Finance Costs" ||
        x?.name === "Indirect Expenses - Others" ||
        defaultGroupName === "Indirect Expenses - Others" ||
        x?.name === "Legal & Professional Fee" ||
        defaultGroupName === "Legal & Professional Fee" ||
        x?.name === "Selling & Distribution Expenses" ||
        defaultGroupName === "Selling & Distribution Expenses" ||
        x?.name === "Vehicle Expenses" ||
        defaultGroupName === "Vehicle Expenses" ||
        x?.name === "Direct Expenses" ||
        defaultGroupName === "Direct Expenses" ||
        x?.name === "Government Grants" ||
        defaultGroupName === "Government Grants" ||
        x?.name === "Indirect Incomes" ||
        defaultGroupName === "Indirect Incomes"
      ) {
        form.setFieldValue("typeOfDuty", Duty_Type.GST);
        setExpensesAndIncomesDetails(true);
      } else if (
        x?.name === "Cash-in-hand" ||
        defaultGroupName === "Cash-in-hand"
      ) {
        form.setFieldValue(["bankDetail", 0, "accountType"], "");
      }
    } else {
      findParentGroup(x?.parent);
    }
  };

  // Post api
  const saveLedger = () => {
    form
      .validateFields()
      .then(async (value) => {
        setLoading(true);
        console.log("post Data....", value);
        // payTerms;
        setSaveButtonLoading(true);
        let data = {
          ...value,
          vendorPortalEmail: isVendorChecked ? value?.vendorPortalEmail : "",
          addresses: value?.addresses?.map((add: any, index: number) => ({
            ...add,
            address: {
              ...add?.address,
              state:
                gSTTypeValue !== CompanyGSTTypes.Overseas
                  ? add?.address?.state === 0
                    ? undefined
                    : add?.address?.state
                  : undefined,
              overseasState:
                gSTTypeValue === CompanyGSTTypes.Overseas
                  ? add?.address?.state
                  : undefined,
            },
            type: !isPartyCompany ? TypeOfAddress.RegisteredAddress : add.type,
            addressName: !isPartyCompany
              ? index === 0
                ? "Billing Address"
                : "Shipping Address"
              : add?.addressName,
          })),
          partyType: isPartyCompany,
          deleteUploadId: deleteUploadId,
          // gstType: isPartyCompany ? value?.gstType : CompanyGSTTypes.Consumer,
          gstType: value?.gstType,
          gstRate: {
            rate: value?.gstRate?.title ?? value?.gstRate,
            id: value?.gstRate?.value,
            name: value?.gstRate?.label,
          },
          parent: value?.parent?.value ?? value?.parent,
          order: value?.order ?? 1000,
          msmeNo: value?.msmeNo ? `UDYAM-${value?.msmeNo}` : "",
          contactInformation: value?.contactInformation
            ?.filter((c: any) =>
              Object.keys(c).some(
                (key) => c[key] !== undefined && c[key] !== ""
              )
            )
            ?.map((index: any, i: number) => {
              console.log("checkbox", isPartyCompany);
              if (
                i === checkbox ||
                isPartyCompany === PartyType.IndividualPerson
              ) {
                return Object.assign(index, { isDefault: true });
              } else if (i !== checkbox) {
                return Object.assign(index, { isDefault: false });
              }
            }),
          system: false,
          isActive: true,
          isAudited: false,
          editable: true,
          // bankDetail: value?.bankDetail?.map((b: any, index: number) => {
          //   b.isDefault = bankDefaultChecked[index];
          //   return b;
          // }),
          partyDisRate: value?.partyDisRate ?? 0,
          payTerms: {
            creditLimit: value?.payTerms?.creditLimit ?? 0,
            creditPeriod: value?.payTerms?.creditPeriod ?? 0,
          },
        };

        // console.log("post Data....", data);

        await LedgerService.postLedger(currentClient?.id!, data, props?.id)
          .then((res) => {
            if (res.status) {
              // setProps1(true);
              openNotification(
                "success",
                `${res.result?.ledgerName} ${
                  props?.showName ? props?.showName : "Ledger"
                } ${
                  props?.id ? "updated successfully." : "added successfully."
                }`
              );
              props?.setTrigger && props?.setTrigger((x: boolean) => !x);
              setLoading(false);

              props?.setAddLedgerResponse &&
                props?.setAddLedgerResponse({
                  ...res.result,
                  isEdited: props?.id ? true : false,
                });
              props.setOpenDrawer({});
            } else if (res?.message) {
              openNotification("error", res?.message);
              setLoading(false);
            }
            setSaveButtonLoading(false);
          })
          .catch((ex: any) => {
            console.error(ex);
            openNotification("error", ex.message);
            setSaveButtonLoading(false);
            setLoading(false);
          });
      })
      .catch((e) => {
        e?.errorFields[0]?.name[0] &&
          form.scrollToField(e?.errorFields[0]?.name[0]);
        setSaveButtonLoading(false);
        setLoading(false);
      });
  };

  EntryLevelKeys({
    save: () => saveLedger(),
    cancel: () => props?.setOpenDrawer({}),
  });
  useHotkeys("shift+n", () => {});
  // useKeyboardShortcuts("s", ["altKey"], saveLedger);
  // useKeyboardShortcuts("c", ["altKey"], () => props?.setOpenDrawer({}));
  // function handleRemoveKeyPress(
  //   e: React.KeyboardEvent<HTMLSpanElement>,
  //   arg1: () => void
  // ): void {
  //   throw new Error("Function not implemented.");
  // }

  const dutiesAndTaxesOnChange = (e: number) => {
    if (e === 0) {
      setShowFiledDutiedandTaxes({
        taxInDigit: false,
        taxInSelect: true,
        gstType: true,
        calcMethod: false,
      });
    } else if (e === 1 || e === 2) {
      setShowFiledDutiedandTaxes({
        taxInDigit: false,
        taxInSelect: false,
        gstType: false,
        calcMethod: false,
      });
    } else if (e === 3 || e === 4 || e === 5) {
      setShowFiledDutiedandTaxes({
        taxInDigit: true,
        taxInSelect: false,
        gstType: false,
        calcMethod: true,
      });
    }
  };

  useEffect(() => {
    getLedgerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLedgerData = async () => {
    let res = await LedgerService?.getLedgerList(currentClient?.id);
    if (res) {
      console.log("ledgerlist", res);
      setLedgerList(res?.items);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render

  const handleChangeTree = (value: any, label: any, extra: any) => {
    const { triggerNode } = extra;
    if (triggerNode) {
      const { title, value, parent } = triggerNode.props;
      // const customObject = {
      //   title: title,
      //   value: value,
      //   parent: parent,
      // };
      findParentGroup(value, title);
    } else {
      console.warn("Node data is null or not returned.");
    }
  };

  React.useEffect(() => {
    if (addGroupVal) {
      form.setFieldsValue({
        parent: {
          value: addGroupVal?.id,
          label: addGroupVal?.name,
        },
      });
      findParentGroup(addGroupVal?.id);
    }
  }, [addGroupVal, form]);

  // console.log("val", countryOptionsOnlyIndia?.[0]?.label);
  // setCountry(countryOptionsOnlyIndia?.[0]?.label);
  return (
    <Fragment>
      <Drawer
        title={
          <>
            <Row justify={"space-between"}>
              <Col style={{ fontSize: "16px" }}>
                {props?.id === ""
                  ? `Add ${props?.showName ? props?.showName : "Ledger"}`
                  : `Edit ${props?.showName ? props?.showName : "Ledger"}`}
              </Col>
              {(showPersonCompany ||
                props?.type === SearchLedgerByGroupsTypes.PartiesOnly ||
                props?.type === SearchLedgerByGroupsTypes.DebtorsOnly ||
                props?.type === SearchLedgerByGroupsTypes.CreditorsOnly) && (
                <Col
                  style={{
                    marginRight: "20px",
                    border: "solid #d2d4d6 1px",
                    borderRadius: "40px",
                  }}
                >
                  <Radio.Group
                    buttonStyle="solid"
                    value={isPartyCompany}
                    disabled={editTimeIsCompany === PartyType.CompanyFirm}
                  >
                    <Radio.Button
                      style={{
                        borderRadius: "40px 0px 0px 40px",
                        margin: "1px",
                      }}
                      value={PartyType.IndividualPerson}
                      onChange={(e) => {
                        let contactInfo =
                          form.getFieldValue("contactInformation");
                        let selContactInfo =
                          contactInfo?.filter((cInfo: any) => cInfo?.isDefault)
                            ?.length > 0
                            ? contactInfo.filter(
                                (cInfo: any) => cInfo.isDefault
                              )[0]
                            : contactInfo[0];
                        if (
                          contactInfo &&
                          e?.target?.value == PartyType.IndividualPerson
                        ) {
                          form.setFieldValue("contactInformation", [
                            {
                              ...selContactInfo,
                            },
                          ]);
                        }
                        setIsPartyCompany(e?.target?.value);
                        handlePartyTypeChange(e?.target?.value);
                      }}
                      // form.validateFields(["addresses"]);
                    >
                      Individual / Person
                    </Radio.Button>

                    <Radio.Button
                      style={{
                        borderRadius: "0px 40px 40px 0px",
                        margin: "1px",
                      }}
                      value={PartyType.CompanyFirm}
                      onChange={(e) => {
                        let contactInfo =
                          form.getFieldValue("contactInformation");
                        if (
                          contactInfo &&
                          e?.target?.value == PartyType.CompanyFirm
                        ) {
                          form.setFieldValue("contactInformation", [
                            { ...contactInfo[0] },
                          ]);
                        }
                        let addressInfo = form
                          .getFieldValue("addresses")
                          .filter(
                            (add: any) =>
                              add?.address?.building ||
                              add?.address?.landmark ||
                              add?.address?.city ||
                              add?.address?.street ||
                              add?.address?.pincode ||
                              add?.address?.state
                          );
                        if (
                          addressInfo.length > 0 &&
                          e?.target?.value == PartyType.CompanyFirm
                        ) {
                          form.setFieldValue("addresses", [...addressInfo]);
                        } else {
                          form.setFieldValue("addresses", [
                            { address: { country: country } },
                          ]);
                        }
                        setIsPartyCompany(e?.target?.value);
                        handlePartyTypeChange(e?.target?.value);
                        // form.setFieldValue(
                        //   ["addresses"],
                        //   [{ address: { country: country } }]
                        // );
                        form.validateFields([
                          ["addresses", 0, "address", "state"],
                        ]);
                      }}
                    >
                      Business Entity
                    </Radio.Button>
                  </Radio.Group>
                </Col>
              )}
            </Row>
          </>
        }
        open={props.openDrawer}
        // onClose={onClose}
        width={getwidth()}
        maskClosable={false}
        closable={false}
        placement={props?.placement ?? "right"}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.setOpenDrawer({})} />
          </Space>
        }
        footer={
          <Space
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: 20,
            }}
          >
            <>
              <Tooltip title={<p>ALT+C</p>} placement="topLeft" open={showKeys}>
                <Button onClick={() => props.setOpenDrawer({})}>Cancel</Button>
              </Tooltip>
            </>
            <>
              <Tooltip title={<p>ALT+S</p>} placement="topLeft" open={showKeys}>
                <Button
                  onClick={() => saveLedger()}
                  type="primary"
                  loading={saveButtonLoading}
                >
                  {props?.id === "" ? "Save" : "Update"}
                </Button>
              </Tooltip>
            </>
          </Space>
        }
        className="ledgerdrawerstyle"
      >
        <Spin indicator={antIcon} spinning={loading}>
          <Form
            form={form}
            name="customers"
            colon={false}
            requiredMark={true}
            initialValues={{
              // openingstock: Utils.getFormattedNumber(0),
              // atprice: 0,
              // totalprice: 0,
              bankDetail: [{}],
              contactInformation: [{}],
              // addresses: [{ }],
              addresses: [
                // { address: { country: "IN" } },
                // { address: { country: "IN" } },
                {},
              ],
              parent: props?.name,
              gstType:
                isPartyCompany === PartyType.CompanyFirm
                  ? CompanyGSTTypes.Unregistered
                  : CompanyGSTTypes.Consumer,
              // gstTypeIndividual: CompanyGSTTypes.Consumer,
              // typeOfDuty: Duty_Type.GST,
              // type: 0,
              // gstType: 0,
            }}
            scrollToFirstError
            autoComplete="off"
            layout="vertical"
          >
            <Row
              gutter={14}
              style={{ justifyContent: width <= 375 ? "center" : "" }}
            >
              <Col lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                  name="ledgerName"
                  className="inputBoxMb8 inputLabel33"
                  label={`${props?.showName ? props?.showName : "Ledger"} Name`}
                  rules={[
                    {
                      required: true,
                      message: `${
                        props?.showName ? props?.showName : "Ledger"
                      }  name is required`,
                    },
                    {
                      pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                      message:
                        "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                    },
                    {
                      min: 3,
                      max: 80,
                      message:
                        "Length must be Minimum 3 or Maximum 80 characters long",
                    },
                    {
                      validator: (_) => {
                        if (ledgerAvailable) {
                          return Promise.reject("Name already exists.");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    ref={autoCompleteRef}
                    autoFocus
                    placeholder={`${
                      props?.showName ? props?.showName : "Ledger"
                    } name`}
                    onChange={(e: any) => handleInputChange(e.target?.value)}
                  />
                  {/* <AutoComplete
                    // ref={autoCompleteRef}
                    style={{ width: "100%" }}
                    options={ledgerList?.map((value: any) => ({
                      value: value?.ledgerName,
                      title: value?.parent,
                    }))}
                                          placeholder={`${
                      props?.showName ? props?.showName : "Ledger"
                    } name`}
                    // filterOption={(inputValue, option) =>
                    //   option?.value
                    //     ?.toUpperCase()
                    //     .indexOf(inputValue?.toUpperCase()) !== -1
                    // }                    
                    value={inputValue}
                    onFocus={() => setOpen(true)}
                    onChange={handleInputChange}
                    onSelect={(value) => {
                      handleInputChange(value);
                      setOpen(false);
                    }}
                    onBlur={() => setOpen(false)}
                    open={open}
                    maxLength={80}
                  ></AutoComplete> */}
                </Form.Item>
              </Col>
              <Col lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                  name="aliasName"
                  className="inputBoxMb8 inputLabel33"
                  label="Alias/Short Name"
                  rules={[
                    {
                      min: 3,
                      max: 20,
                      message:
                        "Length must be Minimum 3 or Maximum 80 characters long",
                    },
                    {
                      pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                      message:
                        "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                    },
                  ]}
                >
                  <Input
                    minLength={3}
                    maxLength={20}
                    onChange={(e: any) => {
                      const newvalue = e.target.value;
                      const capitalvalue =
                        newvalue.charAt(0).toUpperCase() + newvalue.slice(1);
                      form.setFieldValue("aliasName", capitalvalue);
                    }}
                    // style={{
                    //   width: window.innerWidth <= 425 ? "226px" : " ",
                    // }}
                  />
                </Form.Item>
              </Col>
              {/* <Col lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                  name="order"
                  label="Order"
                  className="inputBoxMb8 inputLabel33"
                >
                  <InputNumber style={{ width: "100%" }} controls={false} />
                </Form.Item>
              </Col> */}

              <Col lg={8} md={8} sm={12} xs={24}>
                <Form.Item
                  name="parent"
                  label={`${
                    props?.showName ? props?.showName : "Parent"
                  } Group`}
                  className="inputBoxMb8 inputLabel33"
                  rules={[
                    {
                      required: true,
                      message: `${
                        props?.showName ? props?.showName : "Parent"
                      } group is required`,
                    },
                  ]}
                >
                  {/* <Select
                    loading={groupDropdownloading}
                    placeholder="Select group"
                    filterOption={(input, option) =>
                      (option?.label?.toString() ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    labelInValue
                    options={groupData?.map((value: any) => ({
                      value: value?.id,
                      label: value?.group_Name.concat(
                        value?.aliasName
                          ? `${" (" + value?.aliasName + ")"}`
                          : ""
                      ),
                      title: value?.parent,
                    }))}
                    onSelect={(e) => console.log(e)}
                    onChange={(e) => findParentGroup(e.title, e.label)}
                    showSearch
                    dropdownRender={(customerOptions) => (
                      <>
                        {customerOptions}
                        <Divider style={{ margin: "5px 0px" }} />
                        <Button
                          style={{ width: "100%" }}
                          icon={<PlusOutlined />}
                          type="link"
                          onClick={() =>
                            setOpenModel({ open: true, param: "" })
                          }
                        >
                          New Group
                        </Button>
                      </>
                    )}
                  /> */}
                  <TreeSelect
                    showSearch
                    virtual={false}
                    // loading={groupDropdownloading}
                    style={{ width: "100%" }}
                    labelInValue
                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    placeholder="Please select Group"
                    // allowClear
                    treeDefaultExpandAll
                    onChange={handleChangeTree}
                    treeData={groupDropdownloading ? [] : groupData}
                    treeNodeLabelProp="title"
                    fieldNames={{
                      label: "title",
                      value: "value",
                      children: "children",
                    }}
                    treeNodeFilterProp="title"
                    // onPopupScroll={(e) => console.log("onPopupScroll", e)}
                    dropdownRender={(customerOptions) => (
                      <>
                        {groupDropdownloading ? (
                          <div style={{ padding: 8, textAlign: "center" }}>
                            <Spin
                              indicator={antIcon}
                              spinning={groupDropdownloading}
                            />
                          </div>
                        ) : (
                          <>
                            {customerOptions}
                            {premissionLedgerAndGroup(
                              currentClient?.id!,
                              props.type!,
                              IPermissionActionType.Add,
                              MasterName.Group
                            ) && (
                              <>
                                <Divider style={{ margin: "5px 0px" }} />
                                <Button
                                  style={{ width: "100%" }}
                                  icon={<PlusOutlined />}
                                  type="link"
                                  onClick={() =>
                                    setOpenModel({ open: true, param: "" })
                                  }
                                >
                                  New Group
                                </Button>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Duties & Taxes details  */}
            {dutiesAndTaxesDetails && (
              <div>
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  className="dividertext"
                  style={{ marginTop: "11px", marginBottom: "11px" }}
                >
                  <p style={{ fontWeight: 600 }}>Tax Details</p>
                </Divider>
                <Row gutter={14}>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name="typeOfDuty"
                      label="Duty / Type"
                      className="inputBoxMb8 inputLabel33"
                    >
                      <Select
                        options={[
                          {
                            label: "GST",
                            value: Duty_Type.GST,
                          },
                          {
                            label: "TDS",
                            value: Duty_Type.TDS,
                          },
                          {
                            label: "TCS",
                            value: Duty_Type.TCS,
                          },
                          {
                            label: "Cess",
                            value: Duty_Type.Cess,
                          },
                          {
                            label: "Surcharge",
                            value: Duty_Type.Surcharge,
                          },
                          {
                            label: "Other",
                            value: Duty_Type.Other,
                          },
                        ]}
                        onChange={(e: any) => {
                          dutiesAndTaxesOnChange(e);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  {showFiledDutiedandTaxes.gstType && (
                    <Col lg={6} md={8} sm={12} xs={24}>
                      <Form.Item
                        name="gstTaxType"
                        label="GST Type"
                        className="inputBoxMb8 inputLabel33"
                      >
                        <Select
                          options={[
                            {
                              label: "IGST",
                              value: GSTTax_Type.IntegratedTax,
                            },
                            {
                              label: "CGST",
                              value: GSTTax_Type.CentralTax,
                            },
                            {
                              label: "SGST",
                              value: GSTTax_Type.StateTax,
                            },
                            {
                              label: "UTGST",
                              value: GSTTax_Type.UnionTerritoryTax,
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {showFiledDutiedandTaxes.taxInDigit && (
                    <Col lg={6} md={8} sm={12} xs={24}>
                      <Form.Item
                        name="gstRate"
                        label="Tax Rate"
                        className="inputBoxMb8 inputLabel33"
                      >
                        <InputNumber
                          placeholder="0"
                          addonAfter="%"
                          style={{ width: "100%" }}
                          controls={false}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {showFiledDutiedandTaxes.taxInSelect && (
                    <Col lg={6} md={8} sm={12} xs={24}>
                      <Form.Item
                        name="gstRate"
                        label="Tax Rate"
                        className="inputBoxMb8 inputLabel33"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toString() ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          showSearch
                          labelInValue={true}
                          options={gstOption?.map((gst: any) => ({
                            key: gst.name,
                            value: gst.id,
                            title: gst.rate,
                            label: gst.name,
                          }))}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {showFiledDutiedandTaxes.calcMethod && (
                    <Col lg={6} md={8} sm={12} xs={24}>
                      <Form.Item
                        name="methodOfCalculation"
                        label="Calc Methods"
                        className="inputBoxMb8 inputLabel33"
                      >
                        <Select
                          options={[
                            {
                              label: "TaxBased On ItemRate",
                              value: Duties_Calc_Methods.TaxBasedOnItemRate,
                            },
                            {
                              label: "On Total Sales",
                              value: Duties_Calc_Methods.OnTotalSales,
                            },
                            {
                              label: "SurchargeOnTax",
                              value: Duties_Calc_Methods.SurchargeOnTax,
                            },
                            {
                              label: "Additional Duty",
                              value: Duties_Calc_Methods.AdditionalDuty,
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </div>
            )}

            {/* { Income & Expensice Tax details } */}
            {expensesAndIncomesDetails && (
              <div>
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  className="dividertext"
                  style={{ marginTop: "11px", marginBottom: "11px" }}
                >
                  <p style={{ fontWeight: 600 }}>Tax Details</p>
                </Divider>
                <Row gutter={14}>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      label="Duty / Type"
                      name="typeOfDuty"
                      className="inputBoxMb8 inputLabel33"
                    >
                      <Select
                        disabled
                        options={[
                          {
                            label: "GST",
                            value: Duty_Type.GST,
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name="gstRate"
                      label="Tax Rate"
                      className="inputBoxMb8 inputLabel33"
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toString() ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        showSearch
                        labelInValue={true}
                        options={gstOption?.map((gst: any) => ({
                          key: gst.name,
                          value: gst.id,
                          title: gst.rate,
                          label: gst.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}

            {/* Party details */}
            {partyViewDetails.sundryDebtors && (
              <>
                {isPartyCompany === PartyType.CompanyFirm && (
                  <>
                    <Divider
                      orientation="left"
                      orientationMargin="0"
                      className="dividertext"
                      style={{ marginTop: "11px", marginBottom: "11px" }}
                    >
                      <p style={{ fontWeight: 600 }}>Business Details</p>
                    </Divider>
                    <Row
                      gutter={14}
                      style={{ justifyContent: width <= 375 ? "center" : "" }}
                    >
                      {/* GST */}
                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="gstType"
                          label="GST Type"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              required: true,
                              message: "Please select the appropriate GST type",
                            },
                          ]}
                        >
                          <Select
                            // value={gSTTypeValue}
                            onChange={(val) => {
                              setSelectCountry([]);
                              if (val !== CompanyGSTTypes.Regular) {
                                form.setFieldValue("gstin", "");
                              }
                              if (val === CompanyGSTTypes.Overseas) {
                                const currentAddresses =
                                  form.getFieldValue("addresses") || [];

                                const updatedAddresses = currentAddresses?.map(
                                  (item: any) => ({
                                    ...item,
                                    address: {
                                      ...item?.address,
                                      state: null,
                                      country: null,
                                    },
                                  })
                                );

                                form.setFieldValue(
                                  "addresses",
                                  updatedAddresses
                                );

                                // form.setFieldValue(
                                //   ["addresses", 0, "address", "state"],
                                //   null
                                // );

                                // form.setFieldValue(
                                //   ["addresses", 1, "address", "state"],
                                //   null
                                // );
                              } else if (
                                gSTTypeValue === CompanyGSTTypes.Overseas &&
                                val !== CompanyGSTTypes.Overseas
                              ) {
                                const currentAddresses =
                                  form.getFieldValue("addresses") || [];
                                const updatedAddresses = currentAddresses?.map(
                                  (item: any) => ({
                                    ...item,
                                    address: {
                                      ...item?.address,
                                      state: null,
                                      country: country,
                                    },
                                  })
                                );
                                form.setFieldValue(
                                  "addresses",
                                  updatedAddresses
                                );
                                // setBillingAddCountry("");
                                // setShippingAddCountry("");
                              }
                              // if (val !== CompanyGSTTypes.Overseas) {
                              //   setBillingAddCountry("IN");
                              //   setShippingAddCountry("IN");
                              // }
                              setGSTTypeValue(val);
                            }}
                            options={GSTTypeOptions.filter(
                              (g) => g.value !== CompanyGSTTypes.Consumer
                            )}
                          />
                        </Form.Item>
                      </Col>

                      {gSTTypeValue !== CompanyGSTTypes.Overseas && (
                        <Col lg={6} md={8} sm={12} xs={24}>
                          <Form.Item
                            name="gstin"
                            className="inputBoxMb8 inputLabel33"
                            label="GSTIN"
                            rules={[
                              {
                                required:
                                  gSTTypeValue ===
                                    CompanyGSTTypes.Unregistered ||
                                  gSTTypeValue === CompanyGSTTypes.Consumer
                                    ? false
                                    : true,
                                message: "GST number is required",
                              },
                              {
                                pattern:
                                  /^(?!00)[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/,
                                message:
                                  "Enter valid 15 alphanumeric GST number",
                              },
                              // {
                              //   min: 15,
                              //   max: 15,
                              //   message: "Length must be 15 characters long",
                              // },
                            ]}
                          >
                            <Input
                              maxLength={15}
                              minLength={15}
                              placeholder="00AABCC1234D1ZZ"
                              allowClear={true}
                              onChange={(e: any) => {
                                const capitalvalue =
                                  e.target.value.toUpperCase();
                                form.setFieldValue("gstin", capitalvalue);
                              }}
                              onBlur={handlePANNo}
                              disabled={
                                gSTTypeValue === CompanyGSTTypes.Unregistered ||
                                gSTTypeValue === CompanyGSTTypes.Consumer
                                  ? true
                                  : false
                              }
                              // onChange={(e: any) => {
                              //   if (e.target.value) setTouched(true);
                              //   else setTouched(false);
                              // }}
                              suffix={<SearchOutlined />}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="pan"
                          className="inputBoxMb8 inputLabel33"
                          label="PAN Card"
                          rules={[
                            {
                              pattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
                              message: "Enter valid 10 alphanumeric PAN number",
                            },
                            {
                              min: 10,
                              max: 10,
                              message: "PAN No. must be 10 characters long",
                            },
                          ]}
                        >
                          <Input
                            disabled={
                              gSTTypeValue === CompanyGSTTypes.Regular ||
                              gSTTypeValue === CompanyGSTTypes.Composition ||
                              gSTTypeValue === CompanyGSTTypes.SEZ ||
                              gSTTypeValue ===
                                CompanyGSTTypes.DeemedExportImport
                                ? true
                                : false
                            }
                            maxLength={10}
                            minLength={10}
                            placeholder="AABCC1234D"
                            onChange={(e: any) => {
                              const capitalvalue = e.target.value.toUpperCase();
                              form.setFieldValue("pan", capitalvalue);
                            }}
                            // style={{
                            //   width: window.innerWidth <= 425 ? "226px" : " ",
                            // }}
                          />
                        </Form.Item>
                      </Col>
                      {gSTTypeValue !== CompanyGSTTypes.Overseas && (
                        <Col lg={6} md={8} sm={12} xs={24}>
                          <Form.Item
                            name="state"
                            label="State"
                            className="inputBoxMb8 inputLabel33"
                            rules={[
                              {
                                required:
                                  gSTTypeValue ===
                                    CompanyGSTTypes.Unregistered ||
                                  gSTTypeValue === CompanyGSTTypes.Consumer
                                    ? true
                                    : false,
                                message: "Please select the State",
                              },
                            ]}
                          >
                            <Select
                              disabled={
                                gSTTypeValue === CompanyGSTTypes.Regular ||
                                gSTTypeValue === CompanyGSTTypes.Composition ||
                                gSTTypeValue === CompanyGSTTypes.SEZ ||
                                gSTTypeValue ===
                                  CompanyGSTTypes.DeemedExportImport
                                  ? true
                                  : false
                              }
                              showSearch
                              placeholder="State"
                              options={Object.entries(stateOptions)?.map(
                                ([key, x]: any) => ({
                                  value: x?.id,
                                  label: x?.name,
                                })
                              )}
                              filterOption={(input, option) =>
                                (option?.label.toString() ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              style={{
                                width: window.innerWidth <= 425 ? "226px" : " ",
                              }}
                              onChange={(e: any) => {
                                console.log(e);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {/* Business  */}

                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="businessType"
                          label="Business Type"
                          className="inputBoxMb8 inputLabel33"
                        >
                          <Select
                            allowClear
                            showSearch
                            options={BusinessTypeOptions}
                            placeholder="Select type"
                            filterOption={(input, option) =>
                              (option?.label?.toString() ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="businessNature"
                          label="Business Nature"
                          className="inputBoxMb8 inputLabel33"
                        >
                          <Select
                            mode="multiple"
                            showSearch={false}
                            placeholder="Select nature"
                            //onChange={handleChange}
                            options={BusinessNaturesTypeOptions}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="website"
                          label="Website"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              type: "url",
                              message: "Please enter a valid URL",
                            },
                            {
                              min: 10,
                              max: 50,
                              message:
                                "Please enter a valid URL having minimum 10 or maximum 50 length",
                            },
                          ]}
                        >
                          <Input
                            minLength={10}
                            maxLength={50}
                            placeholder="https://www.example.com"
                          />
                        </Form.Item>
                      </Col>

                      {/* <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="Tan"
                          label="TAN"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
                              message: "Enter valid 10 alphanumeric TAN number",
                            },
                            {
                              min: 10,
                              max: 10,
                              message: "Length must be 10 characters long",
                            },
                          ]}
                        >
                          <Input
                            placeholder="AAAA99999A"
                            minLength={10}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col> */}

                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="iec"
                          label="IEC"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              pattern: /^[A-Za-z0-9]{10}$/,
                              message: "Enter valid 10 alphanumeric IEC number",
                            },
                            {
                              min: 10,
                              max: 10,
                              message: "Length must be 10 characters long",
                            },
                          ]}
                        >
                          <Input
                            placeholder="IEC Code"
                            minLength={10}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col>

                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="msmeNo"
                          label="MSME Number"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              pattern:
                                /^(?!.*-00-)(?!.*-0{7}$)^[A-Za-z]{2}-[0-9]{2}-[0-9]{7}$/,
                              message:
                                "Enter valid 19 digit MSME No. including '-'",
                            },
                            // {
                            //   min: 19,
                            //   max: 19,
                            //   message:
                            //     "Length must be 19 characters long including '-'.",
                            // },
                          ]}
                        >
                          <Input
                            addonBefore="UDYAM-"
                            placeholder="XX-00-0123456"
                            minLength={13}
                            maxLength={13}
                          />
                        </Form.Item>
                      </Col>

                      {partyViewDetails.sundryCreditor ? (
                        <Col lg={6} md={8} sm={12} xs={24}>
                          <Form.Item
                            name="isTransporter"
                            label="Is Transporter"
                            className="inputBoxMb8 inputLabel33"
                            valuePropName="checked"
                          >
                            <Checkbox
                              disabled={
                                props?.showName === "Transporter" ? true : false
                              }
                            />
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col lg={6} md={8} sm={0}></Col>
                      )}
                    </Row>
                  </>
                )}
                {/* TDS/TCS Detail */}

                {isPartyCompany === PartyType.IndividualPerson && (
                  <Row gutter={14}>
                    <Col lg={8} md={8} sm={12} xs={24}>
                      <Form.Item
                        // name="gstTypeIndividual"
                        name="gstType"
                        label="GST Type"
                        className="inputBoxMb8 inputLabel33"
                        rules={[
                          {
                            required: true,
                            message: "Please select the appropriate GST type",
                          },
                        ]}
                      >
                        <Select
                          // value={gSTTypeValue}
                          onChange={(val) => {
                            if (val === CompanyGSTTypes.Overseas) {
                              const currentAddresses =
                                form.getFieldValue("addresses") || [];

                              const updatedAddresses = currentAddresses?.map(
                                (item: any) => ({
                                  ...item,
                                  address: {
                                    // ...item.address,
                                    country: null,
                                  },
                                })
                              );

                              form.setFieldValue("addresses", updatedAddresses);

                              // form.setFieldValue(
                              //   ["addresses", 0, "address", "state"],
                              //   null
                              // );

                              // form.setFieldValue(
                              //   ["addresses", 1, "address", "state"],
                              //   null
                              // );
                              // setBillingAddCountry("");
                              // setShippingAddCountry("");
                            } else if (val !== CompanyGSTTypes.Overseas) {
                              const currentAddresses =
                                form.getFieldValue("addresses") || [];
                              const updatedAddresses = currentAddresses?.map(
                                (item: any) => ({
                                  ...item,
                                  address: {
                                    // ...item.address,
                                    country: country,
                                  },
                                })
                              );
                              form.setFieldValue("addresses", updatedAddresses);
                              // setBillingAddCountry("");
                              // setShippingAddCountry("");
                            }
                            // if (val !== CompanyGSTTypes.Overseas) {
                            //   setBillingAddCountry("IN");
                            //   setShippingAddCountry("IN");
                            // }
                            setGSTTypeValue(val);
                          }}
                          options={GSTTypeOptionsIndividual}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                {(currentClient?.tdsDeductible! || isPartTDSOrTDS.tds) && (
                  <Row gutter={14}>
                    {(partyViewDetails.sundryDebtors ||
                      partyViewDetails.sundryCreditor) && (
                      <>
                        <Col lg={6} md={8} sm={12} xs={24}>
                          <Form.Item
                            name="tdsDeductible"
                            label="TDS Deductible"
                            className="inputBoxMb8 inputLabel33"
                            valuePropName="checked"
                          >
                            <Checkbox
                              onChange={(e) =>
                                setShowDetailsTDS(e.target.checked)
                              }
                            />
                          </Form.Item>
                        </Col>
                        {showDetailsTDS && (
                          <>
                            <Col lg={6} md={8} sm={12} xs={24}>
                              <Form.Item
                                name="tan"
                                label="TAN"
                                className="inputBoxMb8 inputLabel33"
                                rules={[
                                  {
                                    pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
                                    message:
                                      "Enter valid 10 alphanumeric TAN number",
                                  },
                                  {
                                    min: 10,
                                    max: 10,
                                    message:
                                      "Length must be 10 characters long",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="AAAA99999A"
                                  minLength={10}
                                  maxLength={10}
                                />
                              </Form.Item>
                            </Col>

                            <Col lg={6} md={8} sm={12} xs={24}>
                              <Form.Item
                                name="tdsDeducteeType"
                                label="TDS Deductee Type"
                                className="inputBoxMb8 inputLabel33"
                              >
                                <Select options={DeducteeTypesOptions} />
                              </Form.Item>
                            </Col>
                            <Col lg={6} md={8} sm={12} xs={24}>
                              <Form.Item
                                name="deductTDSinSameVoucher"
                                label={
                                  <span style={{ fontSize: 13 }}>
                                    Deduct TDS in Same Voucher
                                  </span>
                                }
                                className="inputBoxMb8 inputLabel33"
                                valuePropName="checked"
                              >
                                <Checkbox />
                              </Form.Item>
                            </Col>
                            {/* <Col lg={6} md={8} sm={12} xs={24}>
                              <Form.Item
                                name="existingTurnover"
                                label="Existing Turnover"
                                className="inputBoxMb8 inputLabel33"
                              >
                                <Input type="number" />
                              </Form.Item>
                            </Col> */}
                          </>
                        )}
                      </>
                    )}
                  </Row>
                )}

                {/* ----- TCS ----- */}
                {(currentClient?.tcsApplicability! || isPartTDSOrTDS.tcs) && (
                  <Row gutter={14}>
                    {/* {!showDetailsTDS && ( */}
                    <>
                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="ledgerTCSApplicability"
                          label="TCS Applicability"
                          className="inputBoxMb8 inputLabel33"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) =>
                              setShowDetailsTSC(e.target.checked)
                            }
                          />
                        </Form.Item>
                      </Col>
                      {showDetailsTSC && (
                        <>
                          <Col lg={6} md={8} sm={12} xs={24}>
                            <Form.Item
                              name="tcsCollecteeType"
                              label="TCS Collectee Type"
                              className="inputBoxMb8 inputLabel33"
                            >
                              <Select options={DeducteeTypesOptions} />
                            </Form.Item>
                          </Col>
                          {/* <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="ledgerTCSRate"
                          label="TCS Rate"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              required: true,
                              message: "Please input your Rate!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col lg={12} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="ledgerTCSNture"
                          label="TCS Nature"
                          className="inputBoxMb8 inputLabel33"
                          rules={[
                            {
                              required: true,
                              message: "TCS nature is required!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col> */}
                        </>
                      )}
                    </>
                    {/* )} */}
                  </Row>
                )}
                {/*  Contact */}
                <div>
                  <Divider
                    orientation="left"
                    orientationMargin="0"
                    className="dividertext"
                    style={{ marginTop: "11px", marginBottom: "11px" }}
                  >
                    <p style={{ fontWeight: 600 }}>Contact Details</p>
                  </Divider>
                </div>
                {isPartyCompany === PartyType.CompanyFirm ? (
                  <>
                    {" "}
                    <div
                      style={{
                        maxWidth: window.innerWidth <= 425 ? "800px" : "",
                        overflowX: "auto",
                      }}
                    >
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              style={{ width: "20%" }}
                              className="textStart fw-500 "
                            >
                              Name
                            </th>
                            <th
                              style={{ width: "20%" }}
                              className="textStart fw-500 "
                            >
                              Designation
                            </th>
                            <th
                              style={{ width: "15%" }}
                              className="textStart fw-500"
                            >
                              Phone No.
                            </th>
                            <th
                              style={{ width: "18.5%", paddingLeft: "6px" }}
                              className="textStart fw-500"
                            >
                              Email
                            </th>
                            <th
                              style={{ width: "18.5%", paddingLeft: "6px" }}
                              className="textStart fw-500"
                            >
                              CC
                            </th>
                            <th style={{ width: "2%" }}></th>
                          </tr>
                        </thead>
                        <Form.List name="contactInformation">
                          {(fields, { add, remove }) => (
                            <>
                              <tbody>
                                {fields.map(
                                  ({ key, name, ...restField }, index) => (
                                    <tr key={key}>
                                      <td>
                                        <Form.Item
                                          name={[name, "name"]}
                                          {...restField}
                                          className="inputBoxMb8"
                                          rules={[
                                            {
                                              pattern:
                                                /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
                                              message:
                                                "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
                                            },
                                            {
                                              min: 3,
                                              max: 30,
                                              message:
                                                "Length must be Minimum 3 or Maximum 30 characters",
                                            },
                                          ]}
                                        >
                                          <Input
                                            minLength={3}
                                            maxLength={30}
                                            placeholder="Name"
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "designation"]}
                                          {...restField}
                                          className="inputBoxMb8"
                                          rules={[
                                            {
                                              pattern:
                                                /^[A-Za-z][ A-Za-z0-9_()&-]*$/,
                                              message:
                                                "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&' and '-' are allowed",
                                            },
                                            {
                                              min: 3,
                                              max: 30,
                                              message:
                                                "Length must be Minimum 3 or Maximum 30 characters",
                                            },
                                          ]}
                                        >
                                          <Input
                                            minLength={3}
                                            maxLength={30}
                                            placeholder="Designation"
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "phone"]}
                                          {...restField}
                                          className="inputBoxMb8"
                                          rules={[
                                            {
                                              message: "Enter valid Phone No.",
                                              pattern: /^[6-9]{1}[0-9]{9}$/,
                                            },
                                            {
                                              min: 10,
                                              max: 10,
                                              message:
                                                "Length must be 10 digits long",
                                            },
                                          ]}
                                        >
                                          <Input
                                            placeholder="9876543210"
                                            minLength={10}
                                            maxLength={10}
                                            suffix={
                                              <img
                                                src={phoneImg}
                                                alt="phone"
                                              ></img>
                                            }
                                            // addonBefore={
                                            //   <Form.Item
                                            //     name={[name, "prefix"]}
                                            //     {...restField}
                                            //     noStyle
                                            //   >
                                            //     <Select
                                            //       style={{ width: 67 }}
                                            //       options={[
                                            //         { value: "0", label: "+81" },
                                            //         { value: "1", label: "+91" },
                                            //       ]}
                                            //     />
                                            //   </Form.Item>
                                            // }
                                            // maxLength={10}
                                            onKeyPress={(e) =>
                                              !/[0-9]/.test(e.key) &&
                                              e.preventDefault()
                                            }
                                            // onChange={(e) => {
                                            //   if (e.target.value) setTouched(true);
                                            //   else setTouched(false);
                                            // }}
                                            style={{
                                              width:
                                                window.innerWidth <= 425
                                                  ? "160px"
                                                  : "",
                                            }}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "email"]}
                                          {...restField}
                                          className="inputBoxMb8"
                                          rules={[
                                            {
                                              type: "email",
                                              message:
                                                "Enter valid email address",
                                            },
                                            {
                                              min: 10,
                                              max: 80,
                                              message:
                                                "Length must be Minimum 10 or Maximum 80 characters",
                                            },
                                          ]}
                                        >
                                          <Input
                                            placeholder="user@exam.com"
                                            minLength={10}
                                            maxLength={80}
                                            suffix={
                                              <img
                                                src={emailImg}
                                                alt="email"
                                              ></img>
                                            }
                                            // onChange={(e) => {
                                            //   if (e.target.value) setTouched(true);
                                            //   else setTouched(false);
                                            // }}
                                            style={{
                                              width:
                                                window.innerWidth <= 425
                                                  ? "180px"
                                                  : "",
                                            }}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "ccTo"]}
                                          {...restField}
                                          className="inputBoxMb8"
                                          rules={[
                                            {
                                              type: "email",
                                              message:
                                                "Enter valid email address",
                                            },
                                            {
                                              min: 10,
                                              max: 250,
                                              message:
                                                "Length must be Minimum 10 or Maximum 250 characters",
                                            },
                                          ]}
                                        >
                                          <Input
                                            placeholder="user@exam.com"
                                            minLength={10}
                                            maxLength={250}
                                            suffix={
                                              <img
                                                src={emailImg}
                                                alt="email"
                                              ></img>
                                            }
                                            // onChange={(e) => {
                                            //   if (e.target.value) setTouched(true);
                                            //   else setTouched(false);
                                            // }}
                                            style={{
                                              width:
                                                window.innerWidth <= 425
                                                  ? "180px"
                                                  : "",
                                            }}
                                          />
                                        </Form.Item>
                                      </td>

                                      <td>
                                        <Form.Item
                                          className="inputBoxMb8 mleft"
                                          name={[name, "isDefault"]}
                                          valuePropName="checked"
                                          key={index}
                                        >
                                          <Checkbox
                                            checked={checkbox === index}
                                            onChange={() => {
                                              handleIsDefaultChange(index);
                                              // debugger;
                                              // if (checkbox !== index) {
                                              //   setCheckbox(index);
                                              // }
                                            }}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ paddingBottom: "6px" }}>
                                        {fields.length > 1 && (
                                          <Button
                                            style={{
                                              padding: "0px",
                                              borderColor: "#fff",
                                              boxShadow: "none",
                                            }}
                                          >
                                            <DeleteTwoTone
                                              className="ca-delete-btn"
                                              onClick={() => {
                                                if (
                                                  index === 0 &&
                                                  checkbox !== 0
                                                ) {
                                                  setCheckbox(checkbox - 1);
                                                } else if (
                                                  checkbox === 0 &&
                                                  fields.length > 1
                                                ) {
                                                  // console.log("first delete");
                                                  setCheckbox(0);
                                                } else if (
                                                  checkbox !== 0 &&
                                                  checkbox !== 4
                                                ) {
                                                  // console.log("center delete");
                                                  checkbox !== index - 1 &&
                                                    setCheckbox(checkbox - 1);
                                                } else if (
                                                  fields.length === index + 1 &&
                                                  fields.length !== 1
                                                ) {
                                                  // console.log("// last Delete");
                                                  setCheckbox(index - 1);
                                                } else if (
                                                  fields.length === index + 1 &&
                                                  fields.length !== 1
                                                ) {
                                                  setCheckbox(index - 1);
                                                }
                                                return fields.length === 1
                                                  ? ""
                                                  : remove(name);
                                              }}
                                              twoToneColor="#ff879d"
                                            />
                                          </Button>
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>

                              <tfoot>
                                <tr>
                                  <td>
                                    <Form.Item className="inputBoxMb">
                                      <Row>
                                        <Col>
                                          <Button
                                            type="link"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                            disabled={
                                              fields[4]?.name === 4
                                                ? true
                                                : false
                                            }
                                          >
                                            Add Contact
                                          </Button>
                                        </Col>
                                      </Row>
                                    </Form.Item>
                                  </td>
                                </tr>
                              </tfoot>
                            </>
                          )}
                        </Form.List>
                      </table>
                    </div>
                  </>
                ) : (
                  <>
                    <Form.List name="contactInformation">
                      {(fields, { add, remove }) => (
                        <Row gutter={14}>
                          {/* {fields?.map(({ key, name, ...restField }, index) => ( */}
                          <>
                            <Col lg={8} md={8} sm={12} xs={24}>
                              <Form.Item
                                name={[0, "phone"]}
                                className="inputBoxMb8"
                                rules={[
                                  {
                                    message: "Enter valid Phone No.",
                                    pattern: /^[6-9]{1}[0-9]{9}$/,
                                  },
                                  {
                                    min: 10,
                                    max: 10,
                                    message: "Length must be 10 digits long",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="9876543210"
                                  minLength={10}
                                  maxLength={10}
                                  suffix={
                                    <img src={phoneImg} alt="phone"></img>
                                  }
                                  onKeyPress={(e) =>
                                    !/[0-9]/.test(e.key) && e.preventDefault()
                                  }
                                  style={{
                                    width:
                                      window.innerWidth <= 425 ? "160px" : "",
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col lg={8} md={8} sm={12} xs={24}>
                              <Form.Item
                                name={[0, "email"]}
                                // {...restField}
                                className="inputBoxMb8"
                                rules={[
                                  {
                                    type: "email",
                                    message: "Enter valid email address",
                                  },
                                  {
                                    min: 10,
                                    max: 80,
                                    message:
                                      "Length must be Minimum 10 or Maximum 80 characters",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="user@exam.com"
                                  minLength={10}
                                  maxLength={80}
                                  suffix={
                                    <img src={emailImg} alt="email"></img>
                                  }
                                  style={{
                                    width:
                                      window.innerWidth <= 425 ? "180px" : "",
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </>
                          {/* ))} */}
                        </Row>
                      )}
                    </Form.List>
                  </>
                )}
                {/* Address Details */}

                {isPartyCompany ? (
                  <Form.List name="addresses">
                    {(fields, { add, remove }) => (
                      <>
                        <Divider
                          orientation="left"
                          orientationMargin="0"
                          className="dividertext"
                          style={{
                            marginTop: "11px",
                            marginBottom: "11px",
                            fontWeight: 600,
                          }}
                        >
                          Address Details
                        </Divider>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Row
                            gutter={12}
                            style={{
                              justifyContent: width <= 375 ? "center" : "",
                            }}
                          >
                            {fields.length === 1 ? (
                              <Col lg={7} md={7} sm={12}>
                                <Form.Item
                                  name={[name, "type"]}
                                  label="Addresses Type"
                                  className="inputBoxMb inputLabel33 inputBoxMb8"
                                >
                                  <Select
                                    placeholder="Type"
                                    defaultValue={
                                      TypeOfAddress.RegisteredAddress
                                    }
                                    options={[
                                      {
                                        label: "Registered Address",
                                        value: TypeOfAddress.RegisteredAddress,
                                      },
                                      {
                                        label: "Business Address",
                                        value: TypeOfAddress.BusinessAddress,
                                      },
                                      {
                                        label: "Branch Address",
                                        value: TypeOfAddress.BranchAddress,
                                      },
                                      {
                                        label: "Unit Address",
                                        value: TypeOfAddress.UnitAddress,
                                      },
                                      {
                                        label: "Godown Address",
                                        value: TypeOfAddress.GodownAddress,
                                      },
                                    ]}
                                    // TypeOfAddress
                                    style={{
                                      width:
                                        window.innerWidth <= 425
                                          ? "226px"
                                          : " ",
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[name, "addressName"]}
                                  label="Address Name"
                                  className="inputLabel33 inputBoxMb8"
                                  initialValue={"Billing Address"}
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                      message:
                                        "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                    },
                                    {
                                      required: true,
                                      message:
                                        "Please assign a name to address",
                                    },
                                    {
                                      min: 2,
                                      max: 20,
                                      message:
                                        "Length must be Minimum 2 or Maximum 20 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={2} maxLength={20} />
                                </Form.Item>
                              </Col>
                            ) : (
                              <Col lg={7} md={7} sm={12}>
                                <Form.Item
                                  name={[name, "type"]}
                                  label="Addresses Type"
                                  className="inputBoxMb inputLabel33 inputBoxMb8"
                                >
                                  <Select
                                    placeholder="Type"
                                    options={[
                                      {
                                        label: "Registered Address",
                                        value: TypeOfAddress.RegisteredAddress,
                                      },
                                      {
                                        label: "Business Address",
                                        value: TypeOfAddress.BusinessAddress,
                                      },
                                      {
                                        label: "Branch Address",
                                        value: TypeOfAddress.BranchAddress,
                                      },
                                      {
                                        label: "Unit Address",
                                        value: TypeOfAddress.UnitAddress,
                                      },
                                      {
                                        label: "Godown Address",
                                        value: TypeOfAddress.GodownAddress,
                                      },
                                    ]}
                                    // TypeOfAddress
                                    style={{
                                      width:
                                        window.innerWidth <= 425
                                          ? "226px"
                                          : " ",
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[name, "addressName"]}
                                  label="Name"
                                  className="inputLabel33 inputBoxMb8"
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                      message:
                                        "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                    },
                                    {
                                      required: true,
                                      message:
                                        "Please assign a name to address",
                                    },
                                    {
                                      min: 2,
                                      max: 20,
                                      message:
                                        "Length must be Minimum 2 or Maximum 20 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={2} maxLength={20} />
                                </Form.Item>
                              </Col>
                            )}

                            <Col lg={17} md={7} sm={12}>
                              <Form.Item
                                label="Address Detail"
                                className="inputLabel33 inputBoxMb8"
                              >
                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "building"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Building"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "street"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Street"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "landmark"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        maxLength={150} // className="inputBgColor"
                                        placeholder="Landmark"
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "city"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // className="inputBgColor"
                                        minLength={3}
                                        maxLength={30}
                                        placeholder="City"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      className="inputBoxMb"
                                      name={[name, "address", "district"]}
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        minLength={3}
                                        maxLength={30}
                                        // className="inputBgColor"
                                        placeholder="District"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "pincode"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^\d{6}$/,
                                          message:
                                            "Please enter valid 6 digit Pincode",
                                        },
                                        {
                                          min: 6,
                                          max: 6,
                                          message:
                                            "Length must be 6 digits long",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // controls={false}
                                        style={{ width: "100%" }}
                                        // className="inputBgColor"
                                        placeholder="Pincode"
                                        maxLength={6}
                                        minLength={6}
                                        onKeyPress={(e) =>
                                          !/[0-9]/.test(e.key) &&
                                          e.preventDefault()
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "state"]}
                                      className="inputBoxMb"
                                      // rules={[
                                      //   {
                                      //     required: true,
                                      //     message: "Please Select State",
                                      //   },
                                      // ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="State"
                                        onClick={() =>
                                          console.log(
                                            gSTTypeValue,
                                            "State 111",
                                            form.getFieldValue([
                                              "addresses",
                                              index,
                                              "address",
                                              "country",
                                            ]),
                                            allCountriesStates
                                              .find(
                                                (x) =>
                                                  x.iso2 ===
                                                  form.getFieldValue([
                                                    "addresses",
                                                    index,
                                                    "address",
                                                    "country",
                                                  ])
                                              )
                                              ?.states?.map((x) => ({
                                                value: x?.id,
                                                label: x?.name,
                                              }))
                                          )
                                        }
                                        options={
                                          gSTTypeValue !==
                                          CompanyGSTTypes.Overseas
                                            ? Object.entries(stateOptions)?.map(
                                                ([key, x]: any) => ({
                                                  value: x?.id,
                                                  label: x?.name,
                                                })
                                              )
                                            : allCountriesStates
                                                .find(
                                                  (x) =>
                                                    x.iso2 ===
                                                    selectCountry[index]
                                                )
                                                ?.states?.map((x) => ({
                                                  value: x?.id,
                                                  label: x?.name,
                                                }))
                                        }
                                        filterOption={(input, option) =>
                                          (option?.label.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[name, "address", "country"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Country is required",
                                        },
                                      ]}
                                      // initialValue={country}
                                    >
                                      <Select
                                        // disabled={
                                        //   gSTTypeValue !==
                                        //   CompanyGSTTypes.Overseas
                                        // }
                                        // defaultValue={country}
                                        showSearch
                                        placeholder="Country"
                                        options={
                                          gSTTypeValue ===
                                          CompanyGSTTypes.Overseas
                                            ? countryOptionsWithOutIndia
                                            : countryOptionsOnlyIndia
                                        }
                                        allowClear
                                        filterOption={(input, option) =>
                                          (option?.label.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        style={{
                                          width:
                                            window.innerWidth <= 425
                                              ? "226px"
                                              : " ",
                                        }}
                                        onChange={(e) => {
                                          // console.log("e", e);
                                          setSelectCountry((prevValue) => {
                                            const updatedSelectedOptions = [
                                              ...prevValue,
                                            ];
                                            updatedSelectedOptions[index] = e;
                                            return updatedSelectedOptions;
                                          });
                                          if (
                                            e &&
                                            form.getFieldValue([
                                              "addresses",
                                              index,
                                              "address",
                                              "state",
                                            ])
                                          ) {
                                            form.setFieldValue(
                                              [
                                                "addresses",
                                                index,
                                                "address",
                                                "state",
                                              ],
                                              null
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    span={8}
                                    className="pb"
                                    style={{
                                      textAlign: "end",
                                      paddingTop: "10px",
                                      paddingRight: "19px",
                                    }}
                                  >
                                    <Button
                                      style={{
                                        padding: "0px",
                                        borderColor: "#fff",
                                        boxShadow: "none",
                                      }}
                                      onClick={() => {
                                        console.log("test", name);
                                        remove(name);

                                        setSelectCountry((prev) => {
                                          const updatedSelected = [...prev];
                                          updatedSelected.splice(name, 1);
                                          return updatedSelected;
                                        });
                                      }}
                                    >
                                      <DeleteTwoTone
                                        className="ca-delete-btn"
                                        twoToneColor="#ff879d"
                                      />
                                    </Button>
                                  </Col>
                                </Row>
                              </Form.Item>
                            </Col>
                            <Divider style={{ margin: "7px" }} />
                          </Row>
                        ))}
                        <Form.Item className="inputBoxMb">
                          <Row key="add address">
                            <Col>
                              <Button
                                type="link"
                                onClick={() => {
                                  add();

                                  if (
                                    gSTTypeValue !== CompanyGSTTypes.Overseas
                                  ) {
                                    form.setFieldValue(
                                      [
                                        "addresses",
                                        fields.length,
                                        "address",
                                        "country",
                                      ],
                                      country
                                    );
                                    // let currentAddresses =
                                    //   form.getFieldValue("addresses") || [];
                                    // const updatedAddresses =
                                    //   currentAddresses?.map((item: any) => ({
                                    //     ...item,
                                    //     address: {
                                    //       ...item?.address,
                                    //       country: country,
                                    //     },
                                    //   }));

                                    // form.setFieldValue(
                                    //   "addresses",
                                    //   updatedAddresses
                                    // );
                                  }
                                }}
                                block
                                icon={<PlusOutlined />}
                                //disabled={fields[4]?.name === 4 ? true : false}
                              >
                                Add Address
                              </Button>
                            </Col>
                          </Row>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                ) : (
                  <Form.List name="addresses">
                    {(fields, { add, remove }) => (
                      <>
                        {/* {fields.map(({ key, name, ...restField }, index) => ( */}
                        <>
                          {/* Billing Details */}
                          <Divider
                            orientation="left"
                            orientationMargin="0"
                            className="dividertext"
                            style={{
                              marginTop: "11px",
                              marginBottom: "11px",
                              fontWeight: 600,
                            }}
                          >
                            Billing Address
                          </Divider>{" "}
                          <Row
                            gutter={12}
                            style={{
                              justifyContent: width <= 375 ? "center" : "",
                            }}
                          >
                            <Col lg={24} md={7} sm={12}>
                              <Form.Item
                                label="Address Detail"
                                className="inputLabel33 inputBoxMb8"
                              >
                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "building"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Building"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "street"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Street"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "landmark"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        maxLength={150} // className="inputBgColor"
                                        placeholder="Landmark"
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "city"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // className="inputBgColor"
                                        minLength={3}
                                        maxLength={30}
                                        placeholder="City"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      className="inputBoxMb"
                                      name={[0, "address", "district"]}
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        minLength={3}
                                        maxLength={30}
                                        // className="inputBgColor"
                                        placeholder="District"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "pincode"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^\d{6}$/,
                                          message:
                                            "Please enter valid 6 digit Pincode",
                                        },
                                        {
                                          min: 6,
                                          max: 6,
                                          message:
                                            "Length must be 6 digits long",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // controls={false}
                                        style={{ width: "100%" }}
                                        // className="inputBgColor"
                                        placeholder="Pincode"
                                        maxLength={6}
                                        minLength={6}
                                        onKeyPress={(e) =>
                                          !/[0-9]/.test(e.key) &&
                                          e.preventDefault()
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "state"]}
                                      required={true}
                                      className="inputBoxMb"
                                      // {
                                      //   validator: (_) => {
                                      //     if (!isPartyCompany) {
                                      //       return Promise.reject(
                                      //         "Please Select State"
                                      //       );
                                      //     }
                                      //     return Promise.resolve();
                                      //   },
                                      // },
                                      rules={[
                                        {
                                          required:
                                            isPartyCompany ===
                                              PartyType.IndividualPerson &&
                                            gSTTypeValue ===
                                              CompanyGSTTypes.Consumer,
                                          message: "Please Select State",
                                        },
                                      ]}
                                    >
                                      {gSTTypeValue !==
                                      CompanyGSTTypes.Overseas ? (
                                        <Select
                                          showSearch
                                          placeholder="State"
                                          options={Object.entries(
                                            stateOptions
                                          )?.map(([key, x]: any) => ({
                                            value: x?.id,
                                            label: x?.name,
                                          }))}
                                          filterOption={(input, option) =>
                                            (option?.label.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                        />
                                      ) : (
                                        <Select
                                          showSearch
                                          placeholder="State"
                                          options={allCountriesStates
                                            .find(
                                              (x) => x.iso2 === selectCountry[0]
                                            )
                                            ?.states?.map((x) => ({
                                              value: x?.id,
                                              label: x?.name,
                                            }))}
                                          // options={billingAddCountryData?.states?.map(
                                          //   (x: any) => ({
                                          //     value: x?.id,
                                          //     label: x?.name,
                                          //   })
                                          // )}
                                          // filterOption={(input, option) =>
                                          //   (option?.label.toString() ?? "")
                                          //     .toLowerCase()
                                          //     .includes(input.toLowerCase())
                                          // }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[0, "address", "country"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Country is required",
                                        },
                                      ]}
                                      initialValue={country}
                                    >
                                      <Select
                                        // disabled={
                                        //   gSTTypeValue !==
                                        //   CompanyGSTTypes.Overseas
                                        // }
                                        showSearch
                                        placeholder="Country"
                                        options={
                                          gSTTypeValue ===
                                          CompanyGSTTypes.Overseas
                                            ? countryOptionsWithOutIndia
                                            : countryOptionsOnlyIndia
                                        }
                                        allowClear
                                        filterOption={(input, option) =>
                                          (option?.label.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        style={{
                                          width:
                                            window.innerWidth <= 425
                                              ? "226px"
                                              : " ",
                                        }}
                                        onChange={(e) => {
                                          // console.log("e", e);

                                          setSelectCountry((prevValue) => {
                                            const updatedSelectedOptions = [
                                              ...prevValue,
                                            ];
                                            updatedSelectedOptions[0] = e;
                                            return updatedSelectedOptions;
                                          });
                                          if (
                                            e &&
                                            form.getFieldValue([
                                              "addresses",
                                              0,
                                              "address",
                                              "state",
                                            ])
                                          ) {
                                            form.setFieldValue(
                                              [
                                                "addresses",
                                                0,
                                                "address",
                                                "state",
                                              ],
                                              null
                                            );
                                          }
                                          // const countryData =
                                          //   allCountriesStates.find(
                                          //     (x) => x.iso2 === e
                                          //   );

                                          // if (countryData?.iso2) {
                                          //   setBillingAddCountry(
                                          //     countryData?.iso2
                                          //   );
                                          //   // const state = countryData?.states?.map((x)=> );
                                          //   setBillingAddCountryData(
                                          //     countryData
                                          //   );
                                          //   console.log(
                                          //     "countryData",
                                          //     countryData,
                                          //     e === countryData?.iso2
                                          //   );
                                          // }
                                          // else {
                                          //   form.setFieldValue(
                                          //     [
                                          //       "addresses",
                                          //       0,
                                          //       "address",
                                          //       "state",
                                          //     ],
                                          //     null
                                          //   );
                                          //   setBillingAddCountryData({});
                                          // }
                                        }}
                                      />
                                      {/* <Input
                                      minLength={3}
                                      maxLength={30}
                                      placeholder="Country"
                                    /> */}
                                      {/* <Select
                                      // className="selectBgColor"
                                      showSearch
                                      placeholder="country"
                                      optionFilterProp="children"
                                      // filterOption={(input, option) =>
                                      //   (option?.label ?? "")
                                      //     .toLowerCase()
                                      //     .includes(input.toLowerCase())
                                      // }
                                      // options={statesOption.map((x: any) => ({
                                      //   value: x.id,
                                      //   label: x.name,
                                      // }))}
                                    /> */}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form.Item>
                            </Col>
                            {/* <Divider style={{ margin: "7px" }} /> */}
                          </Row>
                          {/* Shipping Detail */}
                          <Divider
                            orientation="left"
                            orientationMargin="0"
                            className="dividertext"
                            style={{
                              marginTop: "11px",
                              marginBottom: "11px",
                              fontWeight: 600,
                            }}
                          >
                            <Space>
                              <span>Shipping Address</span>
                              <span></span>
                            </Space>
                          </Divider>{" "}
                          <Row
                            gutter={12}
                            style={{
                              justifyContent: width <= 375 ? "center" : "",
                            }}
                          >
                            <Col lg={24} md={7} sm={12}>
                              <Form.Item
                                label="Address Detail"
                                className="inputLabel33 inputBoxMb8"
                              >
                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "building"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Building"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "street"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Street"
                                        maxLength={150}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "landmark"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          max: 150,
                                          message:
                                            "Maximum 150 characters are allowed",
                                        },
                                      ]}
                                    >
                                      <Input
                                        maxLength={150} // className="inputBgColor"
                                        placeholder="Landmark"
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "city"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // className="inputBgColor"
                                        minLength={3}
                                        maxLength={30}
                                        placeholder="City"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      className="inputBoxMb"
                                      name={[1, "address", "district"]}
                                      rules={[
                                        {
                                          pattern: /^[A-Za-z][ A-Za-z()&]*$/,
                                          message:
                                            "Only alphabets with space and some special characters i.e. '(', ')' and '&' are allowed",
                                        },
                                        {
                                          min: 3,
                                          max: 30,
                                          message:
                                            "Length must be Minimum 3 or Maximum 30 characters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        minLength={3}
                                        maxLength={30}
                                        // className="inputBgColor"
                                        placeholder="District"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "pincode"]}
                                      className="inputBoxMb"
                                      rules={[
                                        {
                                          pattern: /^\d{6}$/,
                                          message:
                                            "Please enter valid 6 digit Pincode",
                                        },
                                        {
                                          min: 6,
                                          max: 6,
                                          message:
                                            "Length must be 6 digits long",
                                        },
                                      ]}
                                    >
                                      <Input
                                        // controls={false}
                                        style={{ width: "100%" }}
                                        // className="inputBgColor"
                                        placeholder="Pincode"
                                        maxLength={6}
                                        minLength={6}
                                        onKeyPress={(e) =>
                                          !/[0-9]/.test(e.key) &&
                                          e.preventDefault()
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "state"]}
                                      className="inputBoxMb"
                                      // rules={[
                                      //   {
                                      //     required: !isPartyCompany,
                                      //     message: "Please Select State",
                                      //   },
                                      // ]}
                                    >
                                      {gSTTypeValue !==
                                      CompanyGSTTypes.Overseas ? (
                                        <Select
                                          showSearch
                                          placeholder="State"
                                          options={Object.entries(
                                            stateOptions
                                          )?.map(([key, x]: any) => ({
                                            value: x?.id,
                                            label: x?.name,
                                          }))}
                                          filterOption={(input, option) =>
                                            (option?.label.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                        />
                                      ) : (
                                        <Select
                                          showSearch
                                          placeholder="State"
                                          options={allCountriesStates
                                            .find(
                                              (x) => x.iso2 === selectCountry[1]
                                            )
                                            ?.states?.map((x) => ({
                                              value: x?.id,
                                              label: x?.name,
                                            }))}
                                          // options={shippingAddCountryData?.states?.map(
                                          //   (x: any) => ({
                                          //     value: x?.id,
                                          //     label: x?.name,
                                          //   })
                                          // )}
                                          // filterOption={(input, option) =>
                                          //   (option?.label.toString() ?? "")
                                          //     .toLowerCase()
                                          //     .includes(input.toLowerCase())
                                          // }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name={[1, "address", "country"]}
                                      className="inputBoxMb"
                                      // rules={[
                                      //   {
                                      //     required: true,
                                      //     message: "Country is required",
                                      //   },
                                      // ]}
                                      initialValue={country}
                                    >
                                      <Select
                                        showSearch
                                        // disabled={
                                        //   gSTTypeValue !==
                                        //   CompanyGSTTypes.Overseas
                                        // }
                                        placeholder="Country"
                                        options={
                                          gSTTypeValue ===
                                          CompanyGSTTypes.Overseas
                                            ? countryOptionsWithOutIndia
                                            : countryOptionsOnlyIndia
                                        }
                                        allowClear
                                        filterOption={(input, option) =>
                                          (option?.label.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        onChange={(e) => {
                                          setSelectCountry((prevValue) => {
                                            const updatedSelectedOptions = [
                                              ...prevValue,
                                            ];
                                            updatedSelectedOptions[1] = e;
                                            return updatedSelectedOptions;
                                          });
                                          console.log(
                                            "addresses 11",
                                            form.getFieldValue([
                                              "addresses",
                                              1,
                                              "address",
                                              "state",
                                            ])
                                          );
                                          if (
                                            e &&
                                            form.getFieldValue([
                                              "addresses",
                                              1,
                                              "address",
                                              "state",
                                            ])
                                          ) {
                                            form.setFieldValue(
                                              [
                                                "addresses",
                                                1,
                                                "address",
                                                "state",
                                              ],
                                              null
                                            );
                                          }
                                          // const shippingData =
                                          //   allCountriesStates.find(
                                          //     (x) => e === x.iso2
                                          //   );

                                          // if (shippingData?.iso2) {
                                          //   setShippingAddCountry(
                                          //     shippingData?.iso2
                                          //   );
                                          //   setShippingAddCountryData(
                                          //     shippingData
                                          //   );
                                          // }
                                        }}
                                        style={{
                                          width:
                                            window.innerWidth <= 425
                                              ? "226px"
                                              : " ",
                                        }}
                                      />
                                      {/* <Input
                                      minLength={3}
                                      maxLength={30}
                                      placeholder="Country"
                                    /> */}
                                      {/* <Select
                                      // className="selectBgColor"
                                      showSearch
                                      placeholder="country"
                                      optionFilterProp="children"
                                      // filterOption={(input, option) =>
                                      //   (option?.label ?? "")
                                      //     .toLowerCase()
                                      //     .includes(input.toLowerCase())
                                      // }
                                      // options={statesOption.map((x: any) => ({
                                      //   value: x.id,
                                      //   label: x.name,
                                      // }))}
                                    /> */}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form.Item>
                            </Col>
                            {/* <Divider style={{ margin: "7px" }} /> */}
                          </Row>
                        </>
                        {/* // ))} */}
                        {/* <Form.Item className="inputBoxMb">
                        <Row key={"add contact"}>
                          <Col>
                            <Button
                              type="link"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                              //disabled={fields[4]?.name === 4 ? true : false}
                            >
                              Add Address
                            </Button>
                          </Col>
                        </Row>
                      </Form.Item> */}
                      </>
                    )}
                  </Form.List>
                )}
                {/* payTerms */}
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  className="dividertext"
                  style={{ marginTop: "11px", marginBottom: "11px" }}
                >
                  <p style={{ fontWeight: 600 }}> Payment Term</p>
                </Divider>
                <Row gutter={12}>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name={["payTerms", "creditPeriod"]}
                      label="Credit Time (in days)"
                      className="inputBoxMb8 inputLabel33"
                      rules={[
                        {
                          pattern: /^[0-9]+$/,
                          message: "Credit period must be numeric",
                        },
                      ]}
                    >
                      <InputNumber
                        min={0}
                        max={365}
                        placeholder="0"
                        controls={false}
                        style={{ width: "100%" }}
                        onKeyPress={(e) =>
                          !/[0-9]/.test(e.key) && e.preventDefault()
                        }
                        // onChange={(e) => {
                        //   const newValue = e.target.value.replace(/[^0-9]/g,"");
                        //   form.setFieldValue(["payTerms", "creditPeriod"],newValue);
                        // }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name={["payTerms", "creditLimit"]}
                      label="Credit Limit"
                      className="inputBoxMb8 inputLabel33"
                      rules={[
                        {
                          // type: "number",
                          pattern: /^[0-9]+$/,
                          message: "Credit limit must be numeric",
                        },
                      ]}
                    >
                      <InputNumber
                        min={0}
                        max={999999999}
                        controls={false}
                        onKeyPress={(e) =>
                          !/[0-9]/.test(e.key) && e.preventDefault()
                        }
                        // type="number"
                        // onChange={(e) => {
                        //   const newValue = e.target.value.replace(
                        //     /[^0-9]/g,
                        //     ""
                        //   );
                        //   form.setFieldValue(
                        //     ["payTerms", "creditLimit"],
                        //     newValue
                        //   );
                        // }}
                        placeholder="0"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name="partyDisRate"
                      label="Party Discount Rate"
                      className="inputBoxMb8 inputLabel33"
                      rules={[
                        {
                          required: false,
                          message: "Please input the party discount rate!",
                        },
                        {
                          type: "number",
                          min: 0,
                          max: 100,
                          message: "Discount rate must be between 0 and 100 %",
                        },
                      ]}
                    >
                      <InputNumber
                        onKeyPress={(e) => {
                          let currentValue = form.getFieldValue(
                            "partyDisRate"
                          ) as string;
                          !/[0-9.]/.test(e.key) && e.preventDefault();
                          if (
                            e.key === "." &&
                            currentValue.toString().includes(".")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        min={0}
                        precision={2}
                        max={100}
                        style={{ width: "100%" }}
                        controls={false}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            {/* Bank Details */}
            {isPartyCompany === PartyType.CompanyFirm && (
              <>
                {" "}
                {(partyViewDetails.sundryDebtors ||
                  bankViewDetails ||
                  ccViewDetails) && (
                  <Form.List name="bankDetail">
                    {(fields, { add, remove }) => (
                      <>
                        <div>
                          <Divider
                            orientation="left"
                            orientationMargin="0"
                            className="dividertext"
                            style={{ marginTop: "11px", marginBottom: "11px" }}
                          >
                            <p style={{ fontWeight: 600 }}>
                              Bank Details{" "}
                              {fields.length === 0 ? (
                                <Button
                                  style={{ marginLeft: "15px" }}
                                  size="small"
                                  onClick={add}
                                  // type="primary"
                                >
                                  <PlusOutlined />
                                </Button>
                              ) : (
                                ""
                              )}
                            </p>
                          </Divider>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Row key={key} gutter={14}>
                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "accountHolderName"]}
                                  className="inputBoxMb8 inputLabel33"
                                  label="Account Holder Name"
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                                      message:
                                        "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                                    },
                                    {
                                      min: 3,
                                      max: 80,
                                      message:
                                        "Length must be Minimum 3 or Maximum 80 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={3} maxLength={80} />
                                </Form.Item>
                              </Col>
                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "accountNumber"]}
                                  className="inputBoxMb8 inputLabel33"
                                  label="Account Number"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^(?!0+$)\d{6,18}$/),
                                      message:
                                        "Enter valid account number in digits with minimum 6 and maximum 18 length",
                                    },
                                  ]}
                                >
                                  <Input
                                    minLength={6}
                                    maxLength={18}
                                    style={{ width: "100%" }}
                                    // onKeyPress={(e) =>
                                    //   !/[0-9]/.test(e.key) && e.preventDefault()
                                    // }
                                  />
                                </Form.Item>
                              </Col>
                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "accountType"]}
                                  label="Account Type"
                                  className="inputBoxMb8 inputLabel33"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Select Account Type",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder="Account type"
                                    onChange={(val) => {
                                      setBankTypeValue(val);
                                    }}
                                    options={
                                      ccViewDetails
                                        ? [
                                            {
                                              label: "Cash Credit Account",
                                              value:
                                                BankAccountTypes.CashCreditAccount,
                                            },
                                            {
                                              label: "Overdraft Account",
                                              value:
                                                BankAccountTypes.OverdraftAccount,
                                            },
                                            {
                                              label: "Credit Card Account",
                                              value:
                                                BankAccountTypes.CreditCard,
                                            },
                                          ]
                                        : [
                                            {
                                              label: "Saving Account",
                                              value:
                                                BankAccountTypes.SavingAccount,
                                            },
                                            {
                                              label: "Current Account",
                                              value:
                                                BankAccountTypes.CurrentAccount,
                                            },
                                          ]
                                    }
                                    style={{
                                      width:
                                        window.innerWidth <= 425
                                          ? "226px"
                                          : " ",
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "bankName"]}
                                  label="Bank Name"
                                  className="inputBoxMb8 inputLabel33"
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                                      message:
                                        "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                                    },
                                    {
                                      min: 3,
                                      max: 80,
                                      message:
                                        "Length must be Minimum 3 or Maximum 80 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={3} maxLength={80} />
                                </Form.Item>
                              </Col>
                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "ifsCode"]}
                                  label="IFSC Code"
                                  className="inputBoxMb8 inputLabel33"
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z]{4}[0][A-Za-z0-9]{6}$/,
                                      message:
                                        "Input valid 11 alphanumeric IFSC code",
                                    },
                                    {
                                      min: 11,
                                      max: 11,
                                      message:
                                        "Length must be 11 characters long",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="BANK0123456"
                                    maxLength={11}
                                    minLength={11}
                                    onChange={(e: any) => {
                                      const capitalvalue =
                                        e.target.value.toUpperCase();
                                      form.setFieldValue(
                                        [name, "ifsCode"],
                                        capitalvalue
                                      );
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "branch"]}
                                  label="Branch"
                                  className="inputBoxMb8 inputLabel33"
                                  rules={[
                                    {
                                      pattern: /^[A-Za-z][ A-Za-z]*$/,
                                      message: "Enter valid branch's name",
                                    },
                                    {
                                      min: 3,
                                      max: 50,
                                      message:
                                        "Length must be Minimum 3 or Maximum 50 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={3} maxLength={50} />
                                </Form.Item>
                              </Col>

                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  label="OD Limit"
                                  name={[name, "odLimit"]}
                                  className="inputBoxMb8 inputLabel33"
                                >
                                  <InputNumber
                                    min={0}
                                    max={999999999}
                                    controls={false}
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col lg={6} md={8} sm={12} xs={24}>
                                <Form.Item
                                  name={[name, "upiId"]}
                                  label="UPI Id"
                                  className="inputBoxMb8 inputLabel33"
                                  rules={[
                                    {
                                      pattern:
                                        /^[a-zA-Z0-9.\-_]{2,40}@[a-zA-Z]{2,20}$/,
                                      message: "Please enter a valid UPI Id",
                                    },
                                    {
                                      min: 3,
                                      max: 45,
                                      message:
                                        "Length must be Minimum 3 or Maximum 45 characters long",
                                    },
                                  ]}
                                >
                                  <Input minLength={3} maxLength={45} />
                                </Form.Item>
                              </Col>
                              {/* <Col lg={2} md={2} sm={2} xs={2}>
                            <Form.Item
                              name={[name, "isDefault"]}
                              label="Default"
                              className="inputBoxMb8 inputLabel33"
                            >
                              <Checkbox
                                checked={bankDefaultChecked[name]}
                                onChange={({ target }) => {
                                  setBankDefaultValueHandler(
                                    target.checked,
                                    name
                                  );
                                  //console.log("checkbox result: ", e);
                                }}
                              />
                            </Form.Item>
                          </Col>
 */}
                              {bankTypeValue ===
                                BankAccountTypes.CashCreditAccount ||
                              bankTypeValue ===
                                BankAccountTypes.OverdraftAccount ? (
                                <Col lg={6} md={8} sm={12} xs={24}>
                                  <Form.Item
                                    name={[name, "oDLimit"]}
                                    label={
                                      bankTypeValue ===
                                      BankAccountTypes.CashCreditAccount
                                        ? "CC Limit"
                                        : "Over Draft Limit"
                                    }
                                    rules={[
                                      {
                                        pattern: /^[0-9]*$/,
                                        message: "Please enter a valid amount",
                                      },
                                    ]}
                                    className="inputBoxMb8 inputLabel33"
                                  >
                                    <InputNumber
                                      min={0}
                                      controls={false}
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                              ) : (
                                <Col lg={3} md={6} sm={10} xs={22}></Col>
                              )}

                              {partyViewDetails.sundryDebtors && (
                                <Col
                                  span={24}
                                  className="pb"
                                  style={{
                                    textAlign: "end",
                                    // marginTop: "28px",
                                    paddingRight: "10px",
                                  }}
                                >
                                  <Button
                                    style={{
                                      padding: "0px",
                                      borderColor: "#fff",
                                      boxShadow: "none",
                                    }}
                                    onClick={() => {
                                      remove(name);
                                      handleDelBankDetail(name);
                                    }}
                                  >
                                    <DeleteTwoTone
                                      className="ca-delete-btn"
                                      twoToneColor="#ff879d"
                                    />
                                  </Button>
                                </Col>
                              )}
                              {/* <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name={["bankDetail", "odLimit"]}
                      label="Over Draft Limit"
                      className="inputBoxMb8 inputLabel33"
                    >
                      <Input />
                    </Form.Item>
                  </Col> */}
                              <Divider style={{ margin: "7px" }} />
                            </Row>
                          ))}

                          {fields.length === 0 ? (
                            ""
                          ) : (
                            <>
                              {partyViewDetails.sundryDebtors &&
                                fields.length < 3 && (
                                  <Form.Item className="inputBoxMb">
                                    <Row key={"add Bank Detail"}>
                                      <Col>
                                        <Button
                                          type="link"
                                          onClick={() => add()}
                                          block
                                          icon={<PlusOutlined />}
                                        >
                                          Add Bank Detail
                                        </Button>
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                )}
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </Form.List>
                )}
              </>
            )}

            {partyViewDetails.sundryCreditor && (
              <>
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  className="dividertext"
                  style={{ marginTop: "11px", marginBottom: "11px" }}
                />
                <Row gutter={14}>
                  <Col lg={6} md={8} sm={12} xs={24}>
                    <Form.Item
                      name="isVendor"
                      label="Add To Vendor Portal"
                      className="inputBoxMb8 inputLabel3  3"
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={() => {
                          form.setFieldValue("vendorPortalEmail", "");
                          console.log(
                            "vendor Portal Email:",
                            form.getFieldValue("vendorPortalEmail")
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>

                  {isVendorChecked ? (
                    <>
                      <Col lg={6} md={8} sm={12} xs={24}>
                        <Form.Item
                          name="vendorPortalEmail"
                          className="inputBoxMb8"
                          label="Vendor Portal Email"
                          rules={[
                            {
                              required: isVendorChecked,
                              message: "Email is required",
                            },
                            {
                              type: "email",
                              message: "Enter valid email address",
                            },
                            {
                              min: 10,
                              max: 80,
                              message:
                                "Length must be Minimum 10 or Maximum 80 characters",
                            },
                          ]}
                        >
                          <Input
                            placeholder="user@exam.com"
                            minLength={10}
                            maxLength={80}
                            suffix={<img src={emailImg} alt="email"></img>}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : (
                    <Col lg={6} md={8} sm={12} xs={24}></Col>
                  )}
                </Row>
              </>
            )}

            {/* Upload  */}
            <Divider
              orientation="left"
              orientationMargin="0"
              className="dividertext"
              style={{ marginTop: "11px", marginBottom: "11px" }}
            >
              <p style={{ fontWeight: 600 }}>Upload</p>
            </Divider>

            <Row gutter={12}>
              <Col lg={6} md={8} sm={12} xs={24}>
                <Form.Item
                  name="attachments"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    return e.fileList;
                  }}
                  // className="m-0"
                >
                  <Upload
                    multiple
                    // accept={".png, .jpg, .jpeg, .pdf"}
                    // accept={".png, .jpg, .jpeg"}
                    maxCount={5}
                    beforeUpload={() => {
                      return false;
                    }}
                    onRemove={(e: any) => {
                      if (props?.id && e?.id) {
                        setDeleteUploadId([...deleteUploadId, e?.id]);
                      }
                    }}
                    onPreview={(e: any) => {
                      // console.log("preview", e);
                      if (props?.id && e?.path) {
                        setPreviewImage({
                          isBaseConvert: false,
                          path: e,
                        });
                      } else if (e.type?.split("/")[0] === "image") {
                        setPreviewImage({
                          isBaseConvert: true,
                          path: e,
                        });
                      }
                    }}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ backgroundColor: "ButtonFace" }}
                    >
                      Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            {/* {fileList.map((x: any) => {
              return <Row>{x?.name}</Row>;
            })} */}
            {confirmation && (
              <ConfirmationModal
                open={confirmation}
                text="The changes you made will not going to save, are you sure you want to continue?"
                onNo={onDismissConfirm}
                onYes={onDismissBothModels}
              />
            )}
            {previewImage.path && (
              <DocumentPreview
                open={true}
                onCancel={() =>
                  setPreviewImage({
                    path: "",
                    isBaseConvert: false,
                    // uploadType: "",
                  })
                }
                documentDetails={previewImage}
              />
            )}
          </Form>
        </Spin>
      </Drawer>

      {openModel.open && (
        <AddGroup
          open={openModel.open}
          editData={openModel?.param}
          onCancel={() => setOpenModel({ open: false, param: "" })}
          setTrigger={() => setGroupListTrigger(!groupListTrigger)}
          groupData={groupData}
          type={props?.type}
          showName={props?.showName}
          setAddGropVal={setAddGropVal}
        />
      )}
    </Fragment>
  );
};

export default AddLedger;

export const getwidth = () => {
  if (window.innerWidth) {
    return window.innerWidth === 1024 ? 700 : 900;
  }
};
